import e, { useEffect as t, useLayoutEffect as s, createContext as i, forwardRef as r, useState as n, useRef as a } from "react";
import { s as o } from "./style-inject.es-1f59c1d0.js";
function l(e) {
  return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object;
}
function d(e = {}, t = {}) {
  Object.keys(t).forEach(s => {
    void 0 === e[s] ? e[s] = t[s] : l(t[s]) && l(e[s]) && Object.keys(t[s]).length > 0 && d(e[s], t[s]);
  });
}
const c = {
  body: {},
  addEventListener() {},
  removeEventListener() {},
  activeElement: {
    blur() {},
    nodeName: ""
  },
  querySelector: () => null,
  querySelectorAll: () => [],
  getElementById: () => null,
  createEvent: () => ({
    initEvent() {}
  }),
  createElement: () => ({
    children: [],
    childNodes: [],
    style: {},
    setAttribute() {},
    getElementsByTagName: () => []
  }),
  createElementNS: () => ({}),
  importNode: () => null,
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function p() {
  const e = "undefined" != typeof document ? document : {};
  return d(e, c), e;
}
const u = {
  document: c,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {},
    pushState() {},
    go() {},
    back() {}
  },
  CustomEvent: function () {
    return this;
  },
  addEventListener() {},
  removeEventListener() {},
  getComputedStyle: () => ({
    getPropertyValue: () => ""
  }),
  Image() {},
  Date() {},
  screen: {},
  setTimeout() {},
  clearTimeout() {},
  matchMedia: () => ({}),
  requestAnimationFrame: e => "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0),
  cancelAnimationFrame(e) {
    "undefined" != typeof setTimeout && clearTimeout(e);
  }
};
function h() {
  const e = "undefined" != typeof window ? window : {};
  return d(e, u), e;
}
class f extends Array {
  constructor(e) {
    "number" == typeof e ? super(e) : (super(...(e || [])), function (e) {
      const t = e.__proto__;
      Object.defineProperty(e, "__proto__", {
        get: () => t,
        set(e) {
          t.__proto__ = e;
        }
      });
    }(this));
  }
}
function m(e = []) {
  const t = [];
  return e.forEach(e => {
    Array.isArray(e) ? t.push(...m(e)) : t.push(e);
  }), t;
}
function g(e, t) {
  return Array.prototype.filter.call(e, t);
}
function v(e, t) {
  const s = h(),
    i = p();
  let r = [];
  if (!t && e instanceof f) return e;
  if (!e) return new f(r);
  if ("string" == typeof e) {
    const s = e.trim();
    if (s.indexOf("<") >= 0 && s.indexOf(">") >= 0) {
      let e = "div";
      0 === s.indexOf("<li") && (e = "ul"), 0 === s.indexOf("<tr") && (e = "tbody"), 0 !== s.indexOf("<td") && 0 !== s.indexOf("<th") || (e = "tr"), 0 === s.indexOf("<tbody") && (e = "table"), 0 === s.indexOf("<option") && (e = "select");
      const t = i.createElement(e);
      t.innerHTML = s;
      for (let e = 0; e < t.childNodes.length; e += 1) r.push(t.childNodes[e]);
    } else r = function (e, t) {
      if ("string" != typeof e) return [e];
      const s = [],
        i = t.querySelectorAll(e);
      for (let e = 0; e < i.length; e += 1) s.push(i[e]);
      return s;
    }(e.trim(), t || i);
  } else if (e.nodeType || e === s || e === i) r.push(e);else if (Array.isArray(e)) {
    if (e instanceof f) return e;
    r = e;
  }
  return new f(function (e) {
    const t = [];
    for (let s = 0; s < e.length; s += 1) -1 === t.indexOf(e[s]) && t.push(e[s]);
    return t;
  }(r));
}
v.fn = f.prototype;
const w = {
  addClass: function (...e) {
    const t = m(e.map(e => e.split(" ")));
    return this.forEach(e => {
      e.classList.add(...t);
    }), this;
  },
  removeClass: function (...e) {
    const t = m(e.map(e => e.split(" ")));
    return this.forEach(e => {
      e.classList.remove(...t);
    }), this;
  },
  hasClass: function (...e) {
    const t = m(e.map(e => e.split(" ")));
    return g(this, e => t.filter(t => e.classList.contains(t)).length > 0).length > 0;
  },
  toggleClass: function (...e) {
    const t = m(e.map(e => e.split(" ")));
    this.forEach(e => {
      t.forEach(t => {
        e.classList.toggle(t);
      });
    });
  },
  attr: function (e, t) {
    if (1 === arguments.length && "string" == typeof e) return this[0] ? this[0].getAttribute(e) : void 0;
    for (let s = 0; s < this.length; s += 1) if (2 === arguments.length) this[s].setAttribute(e, t);else for (const t in e) this[s][t] = e[t], this[s].setAttribute(t, e[t]);
    return this;
  },
  removeAttr: function (e) {
    for (let t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
    return this;
  },
  transform: function (e) {
    for (let t = 0; t < this.length; t += 1) this[t].style.transform = e;
    return this;
  },
  transition: function (e) {
    for (let t = 0; t < this.length; t += 1) this[t].style.transitionDuration = "string" != typeof e ? `${e}ms` : e;
    return this;
  },
  on: function (...e) {
    let [t, s, i, r] = e;
    function n(e) {
      const t = e.target;
      if (!t) return;
      const r = e.target.dom7EventData || [];
      if (r.indexOf(e) < 0 && r.unshift(e), v(t).is(s)) i.apply(t, r);else {
        const e = v(t).parents();
        for (let t = 0; t < e.length; t += 1) v(e[t]).is(s) && i.apply(e[t], r);
      }
    }
    function a(e) {
      const t = e && e.target && e.target.dom7EventData || [];
      t.indexOf(e) < 0 && t.unshift(e), i.apply(this, t);
    }
    "function" == typeof e[1] && ([t, i, r] = e, s = void 0), r || (r = !1);
    const o = t.split(" ");
    let l;
    for (let e = 0; e < this.length; e += 1) {
      const t = this[e];
      if (s) for (l = 0; l < o.length; l += 1) {
        const e = o[l];
        t.dom7LiveListeners || (t.dom7LiveListeners = {}), t.dom7LiveListeners[e] || (t.dom7LiveListeners[e] = []), t.dom7LiveListeners[e].push({
          listener: i,
          proxyListener: n
        }), t.addEventListener(e, n, r);
      } else for (l = 0; l < o.length; l += 1) {
        const e = o[l];
        t.dom7Listeners || (t.dom7Listeners = {}), t.dom7Listeners[e] || (t.dom7Listeners[e] = []), t.dom7Listeners[e].push({
          listener: i,
          proxyListener: a
        }), t.addEventListener(e, a, r);
      }
    }
    return this;
  },
  off: function (...e) {
    let [t, s, i, r] = e;
    "function" == typeof e[1] && ([t, i, r] = e, s = void 0), r || (r = !1);
    const n = t.split(" ");
    for (let e = 0; e < n.length; e += 1) {
      const t = n[e];
      for (let e = 0; e < this.length; e += 1) {
        const n = this[e];
        let a;
        if (!s && n.dom7Listeners ? a = n.dom7Listeners[t] : s && n.dom7LiveListeners && (a = n.dom7LiveListeners[t]), a && a.length) for (let e = a.length - 1; e >= 0; e -= 1) {
          const s = a[e];
          i && s.listener === i || i && s.listener && s.listener.dom7proxy && s.listener.dom7proxy === i ? (n.removeEventListener(t, s.proxyListener, r), a.splice(e, 1)) : i || (n.removeEventListener(t, s.proxyListener, r), a.splice(e, 1));
        }
      }
    }
    return this;
  },
  trigger: function (...e) {
    const t = h(),
      s = e[0].split(" "),
      i = e[1];
    for (let r = 0; r < s.length; r += 1) {
      const n = s[r];
      for (let s = 0; s < this.length; s += 1) {
        const r = this[s];
        if (t.CustomEvent) {
          const s = new t.CustomEvent(n, {
            detail: i,
            bubbles: !0,
            cancelable: !0
          });
          r.dom7EventData = e.filter((e, t) => t > 0), r.dispatchEvent(s), r.dom7EventData = [], delete r.dom7EventData;
        }
      }
    }
    return this;
  },
  transitionEnd: function (e) {
    const t = this;
    return e && t.on("transitionend", function s(i) {
      i.target === this && (e.call(this, i), t.off("transitionend", s));
    }), this;
  },
  outerWidth: function (e) {
    if (this.length > 0) {
      if (e) {
        const e = this.styles();
        return this[0].offsetWidth + parseFloat(e.getPropertyValue("margin-right")) + parseFloat(e.getPropertyValue("margin-left"));
      }
      return this[0].offsetWidth;
    }
    return null;
  },
  outerHeight: function (e) {
    if (this.length > 0) {
      if (e) {
        const e = this.styles();
        return this[0].offsetHeight + parseFloat(e.getPropertyValue("margin-top")) + parseFloat(e.getPropertyValue("margin-bottom"));
      }
      return this[0].offsetHeight;
    }
    return null;
  },
  styles: function () {
    const e = h();
    return this[0] ? e.getComputedStyle(this[0], null) : {};
  },
  offset: function () {
    if (this.length > 0) {
      const e = h(),
        t = p(),
        s = this[0],
        i = s.getBoundingClientRect(),
        r = t.body,
        n = s.clientTop || r.clientTop || 0,
        a = s.clientLeft || r.clientLeft || 0,
        o = s === e ? e.scrollY : s.scrollTop,
        l = s === e ? e.scrollX : s.scrollLeft;
      return {
        top: i.top + o - n,
        left: i.left + l - a
      };
    }
    return null;
  },
  css: function (e, t) {
    const s = h();
    let i;
    if (1 === arguments.length) {
      if ("string" != typeof e) {
        for (i = 0; i < this.length; i += 1) for (const t in e) this[i].style[t] = e[t];
        return this;
      }
      if (this[0]) return s.getComputedStyle(this[0], null).getPropertyValue(e);
    }
    if (2 === arguments.length && "string" == typeof e) {
      for (i = 0; i < this.length; i += 1) this[i].style[e] = t;
      return this;
    }
    return this;
  },
  each: function (e) {
    return e ? (this.forEach((t, s) => {
      e.apply(t, [t, s]);
    }), this) : this;
  },
  html: function (e) {
    if (void 0 === e) return this[0] ? this[0].innerHTML : null;
    for (let t = 0; t < this.length; t += 1) this[t].innerHTML = e;
    return this;
  },
  text: function (e) {
    if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
    for (let t = 0; t < this.length; t += 1) this[t].textContent = e;
    return this;
  },
  is: function (e) {
    const t = h(),
      s = p(),
      i = this[0];
    let r, n;
    if (!i || void 0 === e) return !1;
    if ("string" == typeof e) {
      if (i.matches) return i.matches(e);
      if (i.webkitMatchesSelector) return i.webkitMatchesSelector(e);
      if (i.msMatchesSelector) return i.msMatchesSelector(e);
      for (r = v(e), n = 0; n < r.length; n += 1) if (r[n] === i) return !0;
      return !1;
    }
    if (e === s) return i === s;
    if (e === t) return i === t;
    if (e.nodeType || e instanceof f) {
      for (r = e.nodeType ? [e] : e, n = 0; n < r.length; n += 1) if (r[n] === i) return !0;
      return !1;
    }
    return !1;
  },
  index: function () {
    let e,
      t = this[0];
    if (t) {
      for (e = 0; null !== (t = t.previousSibling);) 1 === t.nodeType && (e += 1);
      return e;
    }
  },
  eq: function (e) {
    if (void 0 === e) return this;
    const t = this.length;
    if (e > t - 1) return v([]);
    if (e < 0) {
      const s = t + e;
      return v(s < 0 ? [] : [this[s]]);
    }
    return v([this[e]]);
  },
  append: function (...e) {
    let t;
    const s = p();
    for (let i = 0; i < e.length; i += 1) {
      t = e[i];
      for (let e = 0; e < this.length; e += 1) if ("string" == typeof t) {
        const i = s.createElement("div");
        for (i.innerHTML = t; i.firstChild;) this[e].appendChild(i.firstChild);
      } else if (t instanceof f) for (let s = 0; s < t.length; s += 1) this[e].appendChild(t[s]);else this[e].appendChild(t);
    }
    return this;
  },
  prepend: function (e) {
    const t = p();
    let s, i;
    for (s = 0; s < this.length; s += 1) if ("string" == typeof e) {
      const r = t.createElement("div");
      for (r.innerHTML = e, i = r.childNodes.length - 1; i >= 0; i -= 1) this[s].insertBefore(r.childNodes[i], this[s].childNodes[0]);
    } else if (e instanceof f) for (i = 0; i < e.length; i += 1) this[s].insertBefore(e[i], this[s].childNodes[0]);else this[s].insertBefore(e, this[s].childNodes[0]);
    return this;
  },
  next: function (e) {
    return this.length > 0 ? e ? this[0].nextElementSibling && v(this[0].nextElementSibling).is(e) ? v([this[0].nextElementSibling]) : v([]) : this[0].nextElementSibling ? v([this[0].nextElementSibling]) : v([]) : v([]);
  },
  nextAll: function (e) {
    const t = [];
    let s = this[0];
    if (!s) return v([]);
    for (; s.nextElementSibling;) {
      const i = s.nextElementSibling;
      e ? v(i).is(e) && t.push(i) : t.push(i), s = i;
    }
    return v(t);
  },
  prev: function (e) {
    if (this.length > 0) {
      const t = this[0];
      return e ? t.previousElementSibling && v(t.previousElementSibling).is(e) ? v([t.previousElementSibling]) : v([]) : t.previousElementSibling ? v([t.previousElementSibling]) : v([]);
    }
    return v([]);
  },
  prevAll: function (e) {
    const t = [];
    let s = this[0];
    if (!s) return v([]);
    for (; s.previousElementSibling;) {
      const i = s.previousElementSibling;
      e ? v(i).is(e) && t.push(i) : t.push(i), s = i;
    }
    return v(t);
  },
  parent: function (e) {
    const t = [];
    for (let s = 0; s < this.length; s += 1) null !== this[s].parentNode && (e ? v(this[s].parentNode).is(e) && t.push(this[s].parentNode) : t.push(this[s].parentNode));
    return v(t);
  },
  parents: function (e) {
    const t = [];
    for (let s = 0; s < this.length; s += 1) {
      let i = this[s].parentNode;
      for (; i;) e ? v(i).is(e) && t.push(i) : t.push(i), i = i.parentNode;
    }
    return v(t);
  },
  closest: function (e) {
    let t = this;
    return void 0 === e ? v([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
  },
  find: function (e) {
    const t = [];
    for (let s = 0; s < this.length; s += 1) {
      const i = this[s].querySelectorAll(e);
      for (let e = 0; e < i.length; e += 1) t.push(i[e]);
    }
    return v(t);
  },
  children: function (e) {
    const t = [];
    for (let s = 0; s < this.length; s += 1) {
      const i = this[s].children;
      for (let s = 0; s < i.length; s += 1) e && !v(i[s]).is(e) || t.push(i[s]);
    }
    return v(t);
  },
  filter: function (e) {
    return v(g(this, e));
  },
  remove: function () {
    for (let e = 0; e < this.length; e += 1) this[e].parentNode && this[e].parentNode.removeChild(this[e]);
    return this;
  }
};
function A(e, t = 0) {
  return setTimeout(e, t);
}
function b() {
  return Date.now();
}
function S(e, t = "x") {
  const s = h();
  let i, r, n;
  const a = function (e) {
    const t = h();
    let s;
    return t.getComputedStyle && (s = t.getComputedStyle(e, null)), !s && e.currentStyle && (s = e.currentStyle), s || (s = e.style), s;
  }(e);
  return s.WebKitCSSMatrix ? (r = a.transform || a.webkitTransform, r.split(",").length > 6 && (r = r.split(", ").map(e => e.replace(",", ".")).join(", ")), n = new s.WebKitCSSMatrix("none" === r ? "" : r)) : (n = a.MozTransform || a.OTransform || a.MsTransform || a.msTransform || a.transform || a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), i = n.toString().split(",")), "x" === t && (r = s.WebKitCSSMatrix ? n.m41 : 16 === i.length ? parseFloat(i[12]) : parseFloat(i[4])), "y" === t && (r = s.WebKitCSSMatrix ? n.m42 : 16 === i.length ? parseFloat(i[13]) : parseFloat(i[5])), r || 0;
}
function T(e) {
  return "object" == typeof e && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1);
}
function E(...e) {
  const t = Object(e[0]),
    s = ["__proto__", "constructor", "prototype"];
  for (let r = 1; r < e.length; r += 1) {
    const n = e[r];
    if (null != n && (i = n, !("undefined" != typeof window && void 0 !== window.HTMLElement ? i instanceof HTMLElement : i && (1 === i.nodeType || 11 === i.nodeType)))) {
      const e = Object.keys(Object(n)).filter(e => s.indexOf(e) < 0);
      for (let s = 0, i = e.length; s < i; s += 1) {
        const i = e[s],
          r = Object.getOwnPropertyDescriptor(n, i);
        void 0 !== r && r.enumerable && (T(t[i]) && T(n[i]) ? n[i].__swiper__ ? t[i] = n[i] : E(t[i], n[i]) : !T(t[i]) && T(n[i]) ? (t[i] = {}, n[i].__swiper__ ? t[i] = n[i] : E(t[i], n[i])) : t[i] = n[i]);
      }
    }
  }
  var i;
  return t;
}
function x(e, t, s) {
  e.style.setProperty(t, s);
}
function y({
  swiper: e,
  targetPosition: t,
  side: s
}) {
  const i = h(),
    r = -e.translate;
  let n,
    a = null;
  const o = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", i.cancelAnimationFrame(e.cssModeFrameID);
  const l = t > r ? "next" : "prev",
    d = (e, t) => "next" === l && e >= t || "prev" === l && e <= t,
    c = () => {
      n = new Date().getTime(), null === a && (a = n);
      const l = Math.max(Math.min((n - a) / o, 1), 0),
        p = .5 - Math.cos(l * Math.PI) / 2;
      let u = r + p * (t - r);
      if (d(u, t) && (u = t), e.wrapperEl.scrollTo({
        [s]: u
      }), d(u, t)) return e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
          [s]: u
        });
      }), void i.cancelAnimationFrame(e.cssModeFrameID);
      e.cssModeFrameID = i.requestAnimationFrame(c);
    };
  c();
}
let C, P, M;
function k() {
  return C || (C = function () {
    const e = h(),
      t = p();
    return {
      smoothScroll: t.documentElement && "scrollBehavior" in t.documentElement.style,
      touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch),
      passiveListener: function () {
        let t = !1;
        try {
          const s = Object.defineProperty({}, "passive", {
            get() {
              t = !0;
            }
          });
          e.addEventListener("testPassiveListener", null, s);
        } catch (e) {}
        return t;
      }(),
      gestures: "ongesturestart" in e
    };
  }()), C;
}
function O(e = {}) {
  return P || (P = function ({
    userAgent: e
  } = {}) {
    const t = k(),
      s = h(),
      i = s.navigator.platform,
      r = e || s.navigator.userAgent,
      n = {
        ios: !1,
        android: !1
      },
      a = s.screen.width,
      o = s.screen.height,
      l = r.match(/(Android);?[\s\/]+([\d.]+)?/);
    let d = r.match(/(iPad).*OS\s([\d_]+)/);
    const c = r.match(/(iPod)(.*OS\s([\d_]+))?/),
      p = !d && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
      u = "Win32" === i;
    let f = "MacIntel" === i;
    return !d && f && t.touch && ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf(`${a}x${o}`) >= 0 && (d = r.match(/(Version)\/([\d.]+)/), d || (d = [0, 1, "13_0_0"]), f = !1), l && !u && (n.os = "android", n.android = !0), (d || p || c) && (n.os = "ios", n.ios = !0), n;
  }(e)), P;
}
function L() {
  return M || (M = function () {
    const e = h();
    return {
      isSafari: function () {
        const t = e.navigator.userAgent.toLowerCase();
        return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
      }(),
      isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)
    };
  }()), M;
}
Object.keys(w).forEach(e => {
  Object.defineProperty(v.fn, e, {
    value: w[e],
    writable: !0
  });
});
var B = {
  on(e, t, s) {
    const i = this;
    if (!i.eventsListeners || i.destroyed) return i;
    if ("function" != typeof t) return i;
    const r = s ? "unshift" : "push";
    return e.split(" ").forEach(e => {
      i.eventsListeners[e] || (i.eventsListeners[e] = []), i.eventsListeners[e][r](t);
    }), i;
  },
  once(e, t, s) {
    const i = this;
    if (!i.eventsListeners || i.destroyed) return i;
    if ("function" != typeof t) return i;
    function r(...s) {
      i.off(e, r), r.__emitterProxy && delete r.__emitterProxy, t.apply(i, s);
    }
    return r.__emitterProxy = t, i.on(e, r, s);
  },
  onAny(e, t) {
    const s = this;
    if (!s.eventsListeners || s.destroyed) return s;
    if ("function" != typeof e) return s;
    const i = t ? "unshift" : "push";
    return s.eventsAnyListeners.indexOf(e) < 0 && s.eventsAnyListeners[i](e), s;
  },
  offAny(e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed) return t;
    if (!t.eventsAnyListeners) return t;
    const s = t.eventsAnyListeners.indexOf(e);
    return s >= 0 && t.eventsAnyListeners.splice(s, 1), t;
  },
  off(e, t) {
    const s = this;
    return !s.eventsListeners || s.destroyed ? s : s.eventsListeners ? (e.split(" ").forEach(e => {
      void 0 === t ? s.eventsListeners[e] = [] : s.eventsListeners[e] && s.eventsListeners[e].forEach((i, r) => {
        (i === t || i.__emitterProxy && i.__emitterProxy === t) && s.eventsListeners[e].splice(r, 1);
      });
    }), s) : s;
  },
  emit(...e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed) return t;
    if (!t.eventsListeners) return t;
    let s, i, r;
    "string" == typeof e[0] || Array.isArray(e[0]) ? (s = e[0], i = e.slice(1, e.length), r = t) : (s = e[0].events, i = e[0].data, r = e[0].context || t), i.unshift(r);
    return (Array.isArray(s) ? s : s.split(" ")).forEach(e => {
      t.eventsAnyListeners && t.eventsAnyListeners.length && t.eventsAnyListeners.forEach(t => {
        t.apply(r, [e, ...i]);
      }), t.eventsListeners && t.eventsListeners[e] && t.eventsListeners[e].forEach(e => {
        e.apply(r, i);
      });
    }), t;
  }
};
var z = {
  updateSize: function () {
    const e = this;
    let t, s;
    const i = e.$el;
    t = void 0 !== e.params.width && null !== e.params.width ? e.params.width : i[0].clientWidth, s = void 0 !== e.params.height && null !== e.params.height ? e.params.height : i[0].clientHeight, 0 === t && e.isHorizontal() || 0 === s && e.isVertical() || (t = t - parseInt(i.css("padding-left") || 0, 10) - parseInt(i.css("padding-right") || 0, 10), s = s - parseInt(i.css("padding-top") || 0, 10) - parseInt(i.css("padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(s) && (s = 0), Object.assign(e, {
      width: t,
      height: s,
      size: e.isHorizontal() ? t : s
    }));
  },
  updateSlides: function () {
    const e = this;
    function t(t) {
      return e.isHorizontal() ? t : {
        width: "height",
        "margin-top": "margin-left",
        "margin-bottom ": "margin-right",
        "margin-left": "margin-top",
        "margin-right": "margin-bottom",
        "padding-left": "padding-top",
        "padding-right": "padding-bottom",
        marginRight: "marginBottom"
      }[t];
    }
    function s(e, s) {
      return parseFloat(e.getPropertyValue(t(s)) || 0);
    }
    const i = e.params,
      {
        $wrapperEl: r,
        size: n,
        rtlTranslate: a,
        wrongRTL: o
      } = e,
      l = e.virtual && i.virtual.enabled,
      d = l ? e.virtual.slides.length : e.slides.length,
      c = r.children(`.${e.params.slideClass}`),
      p = l ? e.virtual.slides.length : c.length;
    let u = [];
    const h = [],
      f = [];
    let m = i.slidesOffsetBefore;
    "function" == typeof m && (m = i.slidesOffsetBefore.call(e));
    let g = i.slidesOffsetAfter;
    "function" == typeof g && (g = i.slidesOffsetAfter.call(e));
    const v = e.snapGrid.length,
      w = e.slidesGrid.length;
    let A = i.spaceBetween,
      b = -m,
      S = 0,
      T = 0;
    if (void 0 === n) return;
    "string" == typeof A && A.indexOf("%") >= 0 && (A = parseFloat(A.replace("%", "")) / 100 * n), e.virtualSize = -A, a ? c.css({
      marginLeft: "",
      marginBottom: "",
      marginTop: ""
    }) : c.css({
      marginRight: "",
      marginBottom: "",
      marginTop: ""
    }), i.centeredSlides && i.cssMode && (x(e.wrapperEl, "--swiper-centered-offset-before", ""), x(e.wrapperEl, "--swiper-centered-offset-after", ""));
    const E = i.grid && i.grid.rows > 1 && e.grid;
    let y;
    E && e.grid.initSlides(p);
    const C = "auto" === i.slidesPerView && i.breakpoints && Object.keys(i.breakpoints).filter(e => void 0 !== i.breakpoints[e].slidesPerView).length > 0;
    for (let r = 0; r < p; r += 1) {
      y = 0;
      const a = c.eq(r);
      if (E && e.grid.updateSlide(r, a, p, t), "none" !== a.css("display")) {
        if ("auto" === i.slidesPerView) {
          C && (c[r].style[t("width")] = "");
          const n = getComputedStyle(a[0]),
            o = a[0].style.transform,
            l = a[0].style.webkitTransform;
          if (o && (a[0].style.transform = "none"), l && (a[0].style.webkitTransform = "none"), i.roundLengths) y = e.isHorizontal() ? a.outerWidth(!0) : a.outerHeight(!0);else {
            const e = s(n, "width"),
              t = s(n, "padding-left"),
              i = s(n, "padding-right"),
              r = s(n, "margin-left"),
              o = s(n, "margin-right"),
              l = n.getPropertyValue("box-sizing");
            if (l && "border-box" === l) y = e + r + o;else {
              const {
                clientWidth: s,
                offsetWidth: n
              } = a[0];
              y = e + t + i + r + o + (n - s);
            }
          }
          o && (a[0].style.transform = o), l && (a[0].style.webkitTransform = l), i.roundLengths && (y = Math.floor(y));
        } else y = (n - (i.slidesPerView - 1) * A) / i.slidesPerView, i.roundLengths && (y = Math.floor(y)), c[r] && (c[r].style[t("width")] = `${y}px`);
        c[r] && (c[r].swiperSlideSize = y), f.push(y), i.centeredSlides ? (b = b + y / 2 + S / 2 + A, 0 === S && 0 !== r && (b = b - n / 2 - A), 0 === r && (b = b - n / 2 - A), Math.abs(b) < .001 && (b = 0), i.roundLengths && (b = Math.floor(b)), T % i.slidesPerGroup == 0 && u.push(b), h.push(b)) : (i.roundLengths && (b = Math.floor(b)), (T - Math.min(e.params.slidesPerGroupSkip, T)) % e.params.slidesPerGroup == 0 && u.push(b), h.push(b), b = b + y + A), e.virtualSize += y + A, S = y, T += 1;
      }
    }
    if (e.virtualSize = Math.max(e.virtualSize, n) + g, a && o && ("slide" === i.effect || "coverflow" === i.effect) && r.css({
      width: `${e.virtualSize + i.spaceBetween}px`
    }), i.setWrapperSize && r.css({
      [t("width")]: `${e.virtualSize + i.spaceBetween}px`
    }), E && e.grid.updateWrapperSize(y, u, t), !i.centeredSlides) {
      const t = [];
      for (let s = 0; s < u.length; s += 1) {
        let r = u[s];
        i.roundLengths && (r = Math.floor(r)), u[s] <= e.virtualSize - n && t.push(r);
      }
      u = t, Math.floor(e.virtualSize - n) - Math.floor(u[u.length - 1]) > 1 && u.push(e.virtualSize - n);
    }
    if (0 === u.length && (u = [0]), 0 !== i.spaceBetween) {
      const s = e.isHorizontal() && a ? "marginLeft" : t("marginRight");
      c.filter((e, t) => !i.cssMode || t !== c.length - 1).css({
        [s]: `${A}px`
      });
    }
    if (i.centeredSlides && i.centeredSlidesBounds) {
      let e = 0;
      f.forEach(t => {
        e += t + (i.spaceBetween ? i.spaceBetween : 0);
      }), e -= i.spaceBetween;
      const t = e - n;
      u = u.map(e => e < 0 ? -m : e > t ? t + g : e);
    }
    if (i.centerInsufficientSlides) {
      let e = 0;
      if (f.forEach(t => {
        e += t + (i.spaceBetween ? i.spaceBetween : 0);
      }), e -= i.spaceBetween, e < n) {
        const t = (n - e) / 2;
        u.forEach((e, s) => {
          u[s] = e - t;
        }), h.forEach((e, s) => {
          h[s] = e + t;
        });
      }
    }
    if (Object.assign(e, {
      slides: c,
      snapGrid: u,
      slidesGrid: h,
      slidesSizesGrid: f
    }), i.centeredSlides && i.cssMode && !i.centeredSlidesBounds) {
      x(e.wrapperEl, "--swiper-centered-offset-before", -u[0] + "px"), x(e.wrapperEl, "--swiper-centered-offset-after", e.size / 2 - f[f.length - 1] / 2 + "px");
      const t = -e.snapGrid[0],
        s = -e.slidesGrid[0];
      e.snapGrid = e.snapGrid.map(e => e + t), e.slidesGrid = e.slidesGrid.map(e => e + s);
    }
    if (p !== d && e.emit("slidesLengthChange"), u.length !== v && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), h.length !== w && e.emit("slidesGridLengthChange"), i.watchSlidesProgress && e.updateSlidesOffset(), !(l || i.cssMode || "slide" !== i.effect && "fade" !== i.effect)) {
      const t = `${i.containerModifierClass}backface-hidden`,
        s = e.$el.hasClass(t);
      p <= i.maxBackfaceHiddenSlides ? s || e.$el.addClass(t) : s && e.$el.removeClass(t);
    }
  },
  updateAutoHeight: function (e) {
    const t = this,
      s = [],
      i = t.virtual && t.params.virtual.enabled;
    let r,
      n = 0;
    "number" == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed);
    const a = e => i ? t.slides.filter(t => parseInt(t.getAttribute("data-swiper-slide-index"), 10) === e)[0] : t.slides.eq(e)[0];
    if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1) {
      if (t.params.centeredSlides) (t.visibleSlides || v([])).each(e => {
        s.push(e);
      });else for (r = 0; r < Math.ceil(t.params.slidesPerView); r += 1) {
        const e = t.activeIndex + r;
        if (e > t.slides.length && !i) break;
        s.push(a(e));
      }
    } else s.push(a(t.activeIndex));
    for (r = 0; r < s.length; r += 1) if (void 0 !== s[r]) {
      const e = s[r].offsetHeight;
      n = e > n ? e : n;
    }
    (n || 0 === n) && t.$wrapperEl.css("height", `${n}px`);
  },
  updateSlidesOffset: function () {
    const e = this,
      t = e.slides;
    for (let s = 0; s < t.length; s += 1) t[s].swiperSlideOffset = e.isHorizontal() ? t[s].offsetLeft : t[s].offsetTop;
  },
  updateSlidesProgress: function (e = this && this.translate || 0) {
    const t = this,
      s = t.params,
      {
        slides: i,
        rtlTranslate: r,
        snapGrid: n
      } = t;
    if (0 === i.length) return;
    void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
    let a = -e;
    r && (a = e), i.removeClass(s.slideVisibleClass), t.visibleSlidesIndexes = [], t.visibleSlides = [];
    for (let e = 0; e < i.length; e += 1) {
      const o = i[e];
      let l = o.swiperSlideOffset;
      s.cssMode && s.centeredSlides && (l -= i[0].swiperSlideOffset);
      const d = (a + (s.centeredSlides ? t.minTranslate() : 0) - l) / (o.swiperSlideSize + s.spaceBetween),
        c = (a - n[0] + (s.centeredSlides ? t.minTranslate() : 0) - l) / (o.swiperSlideSize + s.spaceBetween),
        p = -(a - l),
        u = p + t.slidesSizesGrid[e];
      (p >= 0 && p < t.size - 1 || u > 1 && u <= t.size || p <= 0 && u >= t.size) && (t.visibleSlides.push(o), t.visibleSlidesIndexes.push(e), i.eq(e).addClass(s.slideVisibleClass)), o.progress = r ? -d : d, o.originalProgress = r ? -c : c;
    }
    t.visibleSlides = v(t.visibleSlides);
  },
  updateProgress: function (e) {
    const t = this;
    if (void 0 === e) {
      const s = t.rtlTranslate ? -1 : 1;
      e = t && t.translate && t.translate * s || 0;
    }
    const s = t.params,
      i = t.maxTranslate() - t.minTranslate();
    let {
      progress: r,
      isBeginning: n,
      isEnd: a
    } = t;
    const o = n,
      l = a;
    0 === i ? (r = 0, n = !0, a = !0) : (r = (e - t.minTranslate()) / i, n = r <= 0, a = r >= 1), Object.assign(t, {
      progress: r,
      isBeginning: n,
      isEnd: a
    }), (s.watchSlidesProgress || s.centeredSlides && s.autoHeight) && t.updateSlidesProgress(e), n && !o && t.emit("reachBeginning toEdge"), a && !l && t.emit("reachEnd toEdge"), (o && !n || l && !a) && t.emit("fromEdge"), t.emit("progress", r);
  },
  updateSlidesClasses: function () {
    const e = this,
      {
        slides: t,
        params: s,
        $wrapperEl: i,
        activeIndex: r,
        realIndex: n
      } = e,
      a = e.virtual && s.virtual.enabled;
    let o;
    t.removeClass(`${s.slideActiveClass} ${s.slideNextClass} ${s.slidePrevClass} ${s.slideDuplicateActiveClass} ${s.slideDuplicateNextClass} ${s.slideDuplicatePrevClass}`), o = a ? e.$wrapperEl.find(`.${s.slideClass}[data-swiper-slide-index="${r}"]`) : t.eq(r), o.addClass(s.slideActiveClass), s.loop && (o.hasClass(s.slideDuplicateClass) ? i.children(`.${s.slideClass}:not(.${s.slideDuplicateClass})[data-swiper-slide-index="${n}"]`).addClass(s.slideDuplicateActiveClass) : i.children(`.${s.slideClass}.${s.slideDuplicateClass}[data-swiper-slide-index="${n}"]`).addClass(s.slideDuplicateActiveClass));
    let l = o.nextAll(`.${s.slideClass}`).eq(0).addClass(s.slideNextClass);
    s.loop && 0 === l.length && (l = t.eq(0), l.addClass(s.slideNextClass));
    let d = o.prevAll(`.${s.slideClass}`).eq(0).addClass(s.slidePrevClass);
    s.loop && 0 === d.length && (d = t.eq(-1), d.addClass(s.slidePrevClass)), s.loop && (l.hasClass(s.slideDuplicateClass) ? i.children(`.${s.slideClass}:not(.${s.slideDuplicateClass})[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(s.slideDuplicateNextClass) : i.children(`.${s.slideClass}.${s.slideDuplicateClass}[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(s.slideDuplicateNextClass), d.hasClass(s.slideDuplicateClass) ? i.children(`.${s.slideClass}:not(.${s.slideDuplicateClass})[data-swiper-slide-index="${d.attr("data-swiper-slide-index")}"]`).addClass(s.slideDuplicatePrevClass) : i.children(`.${s.slideClass}.${s.slideDuplicateClass}[data-swiper-slide-index="${d.attr("data-swiper-slide-index")}"]`).addClass(s.slideDuplicatePrevClass)), e.emitSlidesClasses();
  },
  updateActiveIndex: function (e) {
    const t = this,
      s = t.rtlTranslate ? t.translate : -t.translate,
      {
        slidesGrid: i,
        snapGrid: r,
        params: n,
        activeIndex: a,
        realIndex: o,
        snapIndex: l
      } = t;
    let d,
      c = e;
    if (void 0 === c) {
      for (let e = 0; e < i.length; e += 1) void 0 !== i[e + 1] ? s >= i[e] && s < i[e + 1] - (i[e + 1] - i[e]) / 2 ? c = e : s >= i[e] && s < i[e + 1] && (c = e + 1) : s >= i[e] && (c = e);
      n.normalizeSlideIndex && (c < 0 || void 0 === c) && (c = 0);
    }
    if (r.indexOf(s) >= 0) d = r.indexOf(s);else {
      const e = Math.min(n.slidesPerGroupSkip, c);
      d = e + Math.floor((c - e) / n.slidesPerGroup);
    }
    if (d >= r.length && (d = r.length - 1), c === a) return void (d !== l && (t.snapIndex = d, t.emit("snapIndexChange")));
    const p = parseInt(t.slides.eq(c).attr("data-swiper-slide-index") || c, 10);
    Object.assign(t, {
      snapIndex: d,
      realIndex: p,
      previousIndex: a,
      activeIndex: c
    }), t.emit("activeIndexChange"), t.emit("snapIndexChange"), o !== p && t.emit("realIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && t.emit("slideChange");
  },
  updateClickedSlide: function (e) {
    const t = this,
      s = t.params,
      i = v(e).closest(`.${s.slideClass}`)[0];
    let r,
      n = !1;
    if (i) for (let e = 0; e < t.slides.length; e += 1) if (t.slides[e] === i) {
      n = !0, r = e;
      break;
    }
    if (!i || !n) return t.clickedSlide = void 0, void (t.clickedIndex = void 0);
    t.clickedSlide = i, t.virtual && t.params.virtual.enabled ? t.clickedIndex = parseInt(v(i).attr("data-swiper-slide-index"), 10) : t.clickedIndex = r, s.slideToClickedSlide && void 0 !== t.clickedIndex && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
  }
};
var G = {
  getTranslate: function (e = this.isHorizontal() ? "x" : "y") {
    const {
      params: t,
      rtlTranslate: s,
      translate: i,
      $wrapperEl: r
    } = this;
    if (t.virtualTranslate) return s ? -i : i;
    if (t.cssMode) return i;
    let n = S(r[0], e);
    return s && (n = -n), n || 0;
  },
  setTranslate: function (e, t) {
    const s = this,
      {
        rtlTranslate: i,
        params: r,
        $wrapperEl: n,
        wrapperEl: a,
        progress: o
      } = s;
    let l,
      d = 0,
      c = 0;
    s.isHorizontal() ? d = i ? -e : e : c = e, r.roundLengths && (d = Math.floor(d), c = Math.floor(c)), r.cssMode ? a[s.isHorizontal() ? "scrollLeft" : "scrollTop"] = s.isHorizontal() ? -d : -c : r.virtualTranslate || n.transform(`translate3d(${d}px, ${c}px, 0px)`), s.previousTranslate = s.translate, s.translate = s.isHorizontal() ? d : c;
    const p = s.maxTranslate() - s.minTranslate();
    l = 0 === p ? 0 : (e - s.minTranslate()) / p, l !== o && s.updateProgress(e), s.emit("setTranslate", s.translate, t);
  },
  minTranslate: function () {
    return -this.snapGrid[0];
  },
  maxTranslate: function () {
    return -this.snapGrid[this.snapGrid.length - 1];
  },
  translateTo: function (e = 0, t = this.params.speed, s = !0, i = !0, r) {
    const n = this,
      {
        params: a,
        wrapperEl: o
      } = n;
    if (n.animating && a.preventInteractionOnTransition) return !1;
    const l = n.minTranslate(),
      d = n.maxTranslate();
    let c;
    if (c = i && e > l ? l : i && e < d ? d : e, n.updateProgress(c), a.cssMode) {
      const e = n.isHorizontal();
      if (0 === t) o[e ? "scrollLeft" : "scrollTop"] = -c;else {
        if (!n.support.smoothScroll) return y({
          swiper: n,
          targetPosition: -c,
          side: e ? "left" : "top"
        }), !0;
        o.scrollTo({
          [e ? "left" : "top"]: -c,
          behavior: "smooth"
        });
      }
      return !0;
    }
    return 0 === t ? (n.setTransition(0), n.setTranslate(c), s && (n.emit("beforeTransitionStart", t, r), n.emit("transitionEnd"))) : (n.setTransition(t), n.setTranslate(c), s && (n.emit("beforeTransitionStart", t, r), n.emit("transitionStart")), n.animating || (n.animating = !0, n.onTranslateToWrapperTransitionEnd || (n.onTranslateToWrapperTransitionEnd = function (e) {
      n && !n.destroyed && e.target === this && (n.$wrapperEl[0].removeEventListener("transitionend", n.onTranslateToWrapperTransitionEnd), n.$wrapperEl[0].removeEventListener("webkitTransitionEnd", n.onTranslateToWrapperTransitionEnd), n.onTranslateToWrapperTransitionEnd = null, delete n.onTranslateToWrapperTransitionEnd, s && n.emit("transitionEnd"));
    }), n.$wrapperEl[0].addEventListener("transitionend", n.onTranslateToWrapperTransitionEnd), n.$wrapperEl[0].addEventListener("webkitTransitionEnd", n.onTranslateToWrapperTransitionEnd))), !0;
  }
};
function $({
  swiper: e,
  runCallbacks: t,
  direction: s,
  step: i
}) {
  const {
    activeIndex: r,
    previousIndex: n
  } = e;
  let a = s;
  if (a || (a = r > n ? "next" : r < n ? "prev" : "reset"), e.emit(`transition${i}`), t && r !== n) {
    if ("reset" === a) return void e.emit(`slideResetTransition${i}`);
    e.emit(`slideChangeTransition${i}`), "next" === a ? e.emit(`slideNextTransition${i}`) : e.emit(`slidePrevTransition${i}`);
  }
}
var _ = {
  slideTo: function (e = 0, t = this.params.speed, s = !0, i, r) {
    if ("number" != typeof e && "string" != typeof e) throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof e}] given.`);
    if ("string" == typeof e) {
      const t = parseInt(e, 10);
      if (!isFinite(t)) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`);
      e = t;
    }
    const n = this;
    let a = e;
    a < 0 && (a = 0);
    const {
      params: o,
      snapGrid: l,
      slidesGrid: d,
      previousIndex: c,
      activeIndex: p,
      rtlTranslate: u,
      wrapperEl: h,
      enabled: f
    } = n;
    if (n.animating && o.preventInteractionOnTransition || !f && !i && !r) return !1;
    const m = Math.min(n.params.slidesPerGroupSkip, a);
    let g = m + Math.floor((a - m) / n.params.slidesPerGroup);
    g >= l.length && (g = l.length - 1);
    const v = -l[g];
    if (o.normalizeSlideIndex) for (let e = 0; e < d.length; e += 1) {
      const t = -Math.floor(100 * v),
        s = Math.floor(100 * d[e]),
        i = Math.floor(100 * d[e + 1]);
      void 0 !== d[e + 1] ? t >= s && t < i - (i - s) / 2 ? a = e : t >= s && t < i && (a = e + 1) : t >= s && (a = e);
    }
    if (n.initialized && a !== p) {
      if (!n.allowSlideNext && v < n.translate && v < n.minTranslate()) return !1;
      if (!n.allowSlidePrev && v > n.translate && v > n.maxTranslate() && (p || 0) !== a) return !1;
    }
    let w;
    if (a !== (c || 0) && s && n.emit("beforeSlideChangeStart"), n.updateProgress(v), w = a > p ? "next" : a < p ? "prev" : "reset", u && -v === n.translate || !u && v === n.translate) return n.updateActiveIndex(a), o.autoHeight && n.updateAutoHeight(), n.updateSlidesClasses(), "slide" !== o.effect && n.setTranslate(v), "reset" !== w && (n.transitionStart(s, w), n.transitionEnd(s, w)), !1;
    if (o.cssMode) {
      const e = n.isHorizontal(),
        s = u ? v : -v;
      if (0 === t) {
        const t = n.virtual && n.params.virtual.enabled;
        t && (n.wrapperEl.style.scrollSnapType = "none", n._immediateVirtual = !0), h[e ? "scrollLeft" : "scrollTop"] = s, t && requestAnimationFrame(() => {
          n.wrapperEl.style.scrollSnapType = "", n._swiperImmediateVirtual = !1;
        });
      } else {
        if (!n.support.smoothScroll) return y({
          swiper: n,
          targetPosition: s,
          side: e ? "left" : "top"
        }), !0;
        h.scrollTo({
          [e ? "left" : "top"]: s,
          behavior: "smooth"
        });
      }
      return !0;
    }
    return n.setTransition(t), n.setTranslate(v), n.updateActiveIndex(a), n.updateSlidesClasses(), n.emit("beforeTransitionStart", t, i), n.transitionStart(s, w), 0 === t ? n.transitionEnd(s, w) : n.animating || (n.animating = !0, n.onSlideToWrapperTransitionEnd || (n.onSlideToWrapperTransitionEnd = function (e) {
      n && !n.destroyed && e.target === this && (n.$wrapperEl[0].removeEventListener("transitionend", n.onSlideToWrapperTransitionEnd), n.$wrapperEl[0].removeEventListener("webkitTransitionEnd", n.onSlideToWrapperTransitionEnd), n.onSlideToWrapperTransitionEnd = null, delete n.onSlideToWrapperTransitionEnd, n.transitionEnd(s, w));
    }), n.$wrapperEl[0].addEventListener("transitionend", n.onSlideToWrapperTransitionEnd), n.$wrapperEl[0].addEventListener("webkitTransitionEnd", n.onSlideToWrapperTransitionEnd)), !0;
  },
  slideToLoop: function (e = 0, t = this.params.speed, s = !0, i) {
    if ("string" == typeof e) {
      const t = parseInt(e, 10);
      if (!isFinite(t)) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`);
      e = t;
    }
    const r = this;
    let n = e;
    return r.params.loop && (n += r.loopedSlides), r.slideTo(n, t, s, i);
  },
  slideNext: function (e = this.params.speed, t = !0, s) {
    const i = this,
      {
        animating: r,
        enabled: n,
        params: a
      } = i;
    if (!n) return i;
    let o = a.slidesPerGroup;
    "auto" === a.slidesPerView && 1 === a.slidesPerGroup && a.slidesPerGroupAuto && (o = Math.max(i.slidesPerViewDynamic("current", !0), 1));
    const l = i.activeIndex < a.slidesPerGroupSkip ? 1 : o;
    if (a.loop) {
      if (r && a.loopPreventsSlide) return !1;
      i.loopFix(), i._clientLeft = i.$wrapperEl[0].clientLeft;
    }
    return a.rewind && i.isEnd ? i.slideTo(0, e, t, s) : i.slideTo(i.activeIndex + l, e, t, s);
  },
  slidePrev: function (e = this.params.speed, t = !0, s) {
    const i = this,
      {
        params: r,
        animating: n,
        snapGrid: a,
        slidesGrid: o,
        rtlTranslate: l,
        enabled: d
      } = i;
    if (!d) return i;
    if (r.loop) {
      if (n && r.loopPreventsSlide) return !1;
      i.loopFix(), i._clientLeft = i.$wrapperEl[0].clientLeft;
    }
    function c(e) {
      return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
    }
    const p = c(l ? i.translate : -i.translate),
      u = a.map(e => c(e));
    let h = a[u.indexOf(p) - 1];
    if (void 0 === h && r.cssMode) {
      let e;
      a.forEach((t, s) => {
        p >= t && (e = s);
      }), void 0 !== e && (h = a[e > 0 ? e - 1 : e]);
    }
    let f = 0;
    if (void 0 !== h && (f = o.indexOf(h), f < 0 && (f = i.activeIndex - 1), "auto" === r.slidesPerView && 1 === r.slidesPerGroup && r.slidesPerGroupAuto && (f = f - i.slidesPerViewDynamic("previous", !0) + 1, f = Math.max(f, 0))), r.rewind && i.isBeginning) {
      const r = i.params.virtual && i.params.virtual.enabled && i.virtual ? i.virtual.slides.length - 1 : i.slides.length - 1;
      return i.slideTo(r, e, t, s);
    }
    return i.slideTo(f, e, t, s);
  },
  slideReset: function (e = this.params.speed, t = !0, s) {
    return this.slideTo(this.activeIndex, e, t, s);
  },
  slideToClosest: function (e = this.params.speed, t = !0, s, i = .5) {
    const r = this;
    let n = r.activeIndex;
    const a = Math.min(r.params.slidesPerGroupSkip, n),
      o = a + Math.floor((n - a) / r.params.slidesPerGroup),
      l = r.rtlTranslate ? r.translate : -r.translate;
    if (l >= r.snapGrid[o]) {
      const e = r.snapGrid[o];
      l - e > (r.snapGrid[o + 1] - e) * i && (n += r.params.slidesPerGroup);
    } else {
      const e = r.snapGrid[o - 1];
      l - e <= (r.snapGrid[o] - e) * i && (n -= r.params.slidesPerGroup);
    }
    return n = Math.max(n, 0), n = Math.min(n, r.slidesGrid.length - 1), r.slideTo(n, e, t, s);
  },
  slideToClickedSlide: function () {
    const e = this,
      {
        params: t,
        $wrapperEl: s
      } = e,
      i = "auto" === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView;
    let r,
      n = e.clickedIndex;
    if (t.loop) {
      if (e.animating) return;
      r = parseInt(v(e.clickedSlide).attr("data-swiper-slide-index"), 10), t.centeredSlides ? n < e.loopedSlides - i / 2 || n > e.slides.length - e.loopedSlides + i / 2 ? (e.loopFix(), n = s.children(`.${t.slideClass}[data-swiper-slide-index="${r}"]:not(.${t.slideDuplicateClass})`).eq(0).index(), A(() => {
        e.slideTo(n);
      })) : e.slideTo(n) : n > e.slides.length - i ? (e.loopFix(), n = s.children(`.${t.slideClass}[data-swiper-slide-index="${r}"]:not(.${t.slideDuplicateClass})`).eq(0).index(), A(() => {
        e.slideTo(n);
      })) : e.slideTo(n);
    } else e.slideTo(n);
  }
};
var D = {
  loopCreate: function () {
    const e = this,
      t = p(),
      {
        params: s,
        $wrapperEl: i
      } = e,
      r = i.children().length > 0 ? v(i.children()[0].parentNode) : i;
    r.children(`.${s.slideClass}.${s.slideDuplicateClass}`).remove();
    let n = r.children(`.${s.slideClass}`);
    if (s.loopFillGroupWithBlank) {
      const e = s.slidesPerGroup - n.length % s.slidesPerGroup;
      if (e !== s.slidesPerGroup) {
        for (let i = 0; i < e; i += 1) {
          const e = v(t.createElement("div")).addClass(`${s.slideClass} ${s.slideBlankClass}`);
          r.append(e);
        }
        n = r.children(`.${s.slideClass}`);
      }
    }
    "auto" !== s.slidesPerView || s.loopedSlides || (s.loopedSlides = n.length), e.loopedSlides = Math.ceil(parseFloat(s.loopedSlides || s.slidesPerView, 10)), e.loopedSlides += s.loopAdditionalSlides, e.loopedSlides > n.length && e.params.loopedSlidesLimit && (e.loopedSlides = n.length);
    const a = [],
      o = [];
    n.each((e, t) => {
      v(e).attr("data-swiper-slide-index", t);
    });
    for (let t = 0; t < e.loopedSlides; t += 1) {
      const e = t - Math.floor(t / n.length) * n.length;
      o.push(n.eq(e)[0]), a.unshift(n.eq(n.length - e - 1)[0]);
    }
    for (let e = 0; e < o.length; e += 1) r.append(v(o[e].cloneNode(!0)).addClass(s.slideDuplicateClass));
    for (let e = a.length - 1; e >= 0; e -= 1) r.prepend(v(a[e].cloneNode(!0)).addClass(s.slideDuplicateClass));
  },
  loopFix: function () {
    const e = this;
    e.emit("beforeLoopFix");
    const {
      activeIndex: t,
      slides: s,
      loopedSlides: i,
      allowSlidePrev: r,
      allowSlideNext: n,
      snapGrid: a,
      rtlTranslate: o
    } = e;
    let l;
    e.allowSlidePrev = !0, e.allowSlideNext = !0;
    const d = -a[t] - e.getTranslate();
    if (t < i) {
      l = s.length - 3 * i + t, l += i;
      e.slideTo(l, 0, !1, !0) && 0 !== d && e.setTranslate((o ? -e.translate : e.translate) - d);
    } else if (t >= s.length - i) {
      l = -s.length + t + i, l += i;
      e.slideTo(l, 0, !1, !0) && 0 !== d && e.setTranslate((o ? -e.translate : e.translate) - d);
    }
    e.allowSlidePrev = r, e.allowSlideNext = n, e.emit("loopFix");
  },
  loopDestroy: function () {
    const {
      $wrapperEl: e,
      params: t,
      slides: s
    } = this;
    e.children(`.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`).remove(), s.removeAttr("data-swiper-slide-index");
  }
};
function I(e) {
  const t = this,
    s = p(),
    i = h(),
    r = t.touchEventsData,
    {
      params: n,
      touches: a,
      enabled: o
    } = t;
  if (!o) return;
  if (t.animating && n.preventInteractionOnTransition) return;
  !t.animating && n.cssMode && n.loop && t.loopFix();
  let l = e;
  l.originalEvent && (l = l.originalEvent);
  let d = v(l.target);
  if ("wrapper" === n.touchEventsTarget && !d.closest(t.wrapperEl).length) return;
  if (r.isTouchEvent = "touchstart" === l.type, !r.isTouchEvent && "which" in l && 3 === l.which) return;
  if (!r.isTouchEvent && "button" in l && l.button > 0) return;
  if (r.isTouched && r.isMoved) return;
  const c = !!n.noSwipingClass && "" !== n.noSwipingClass,
    u = e.composedPath ? e.composedPath() : e.path;
  c && l.target && l.target.shadowRoot && u && (d = v(u[0]));
  const f = n.noSwipingSelector ? n.noSwipingSelector : `.${n.noSwipingClass}`,
    m = !(!l.target || !l.target.shadowRoot);
  if (n.noSwiping && (m ? function (e, t = this) {
    return function t(s) {
      if (!s || s === p() || s === h()) return null;
      s.assignedSlot && (s = s.assignedSlot);
      const i = s.closest(e);
      return i || s.getRootNode ? i || t(s.getRootNode().host) : null;
    }(t);
  }(f, d[0]) : d.closest(f)[0])) return void (t.allowClick = !0);
  if (n.swipeHandler && !d.closest(n.swipeHandler)[0]) return;
  a.currentX = "touchstart" === l.type ? l.targetTouches[0].pageX : l.pageX, a.currentY = "touchstart" === l.type ? l.targetTouches[0].pageY : l.pageY;
  const g = a.currentX,
    w = a.currentY,
    A = n.edgeSwipeDetection || n.iOSEdgeSwipeDetection,
    S = n.edgeSwipeThreshold || n.iOSEdgeSwipeThreshold;
  if (A && (g <= S || g >= i.innerWidth - S)) {
    if ("prevent" !== A) return;
    e.preventDefault();
  }
  if (Object.assign(r, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), a.startX = g, a.startY = w, r.touchStartTime = b(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, n.threshold > 0 && (r.allowThresholdMove = !1), "touchstart" !== l.type) {
    let e = !0;
    d.is(r.focusableElements) && (e = !1, "SELECT" === d[0].nodeName && (r.isTouched = !1)), s.activeElement && v(s.activeElement).is(r.focusableElements) && s.activeElement !== d[0] && s.activeElement.blur();
    const i = e && t.allowTouchMove && n.touchStartPreventDefault;
    !n.touchStartForcePreventDefault && !i || d[0].isContentEditable || l.preventDefault();
  }
  t.params.freeMode && t.params.freeMode.enabled && t.freeMode && t.animating && !n.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", l);
}
function N(e) {
  const t = p(),
    s = this,
    i = s.touchEventsData,
    {
      params: r,
      touches: n,
      rtlTranslate: a,
      enabled: o
    } = s;
  if (!o) return;
  let l = e;
  if (l.originalEvent && (l = l.originalEvent), !i.isTouched) return void (i.startMoving && i.isScrolling && s.emit("touchMoveOpposite", l));
  if (i.isTouchEvent && "touchmove" !== l.type) return;
  const d = "touchmove" === l.type && l.targetTouches && (l.targetTouches[0] || l.changedTouches[0]),
    c = "touchmove" === l.type ? d.pageX : l.pageX,
    u = "touchmove" === l.type ? d.pageY : l.pageY;
  if (l.preventedByNestedSwiper) return n.startX = c, void (n.startY = u);
  if (!s.allowTouchMove) return v(l.target).is(i.focusableElements) || (s.allowClick = !1), void (i.isTouched && (Object.assign(n, {
    startX: c,
    startY: u,
    currentX: c,
    currentY: u
  }), i.touchStartTime = b()));
  if (i.isTouchEvent && r.touchReleaseOnEdges && !r.loop) if (s.isVertical()) {
    if (u < n.startY && s.translate <= s.maxTranslate() || u > n.startY && s.translate >= s.minTranslate()) return i.isTouched = !1, void (i.isMoved = !1);
  } else if (c < n.startX && s.translate <= s.maxTranslate() || c > n.startX && s.translate >= s.minTranslate()) return;
  if (i.isTouchEvent && t.activeElement && l.target === t.activeElement && v(l.target).is(i.focusableElements)) return i.isMoved = !0, void (s.allowClick = !1);
  if (i.allowTouchCallbacks && s.emit("touchMove", l), l.targetTouches && l.targetTouches.length > 1) return;
  n.currentX = c, n.currentY = u;
  const h = n.currentX - n.startX,
    f = n.currentY - n.startY;
  if (s.params.threshold && Math.sqrt(h ** 2 + f ** 2) < s.params.threshold) return;
  if (void 0 === i.isScrolling) {
    let e;
    s.isHorizontal() && n.currentY === n.startY || s.isVertical() && n.currentX === n.startX ? i.isScrolling = !1 : h * h + f * f >= 25 && (e = 180 * Math.atan2(Math.abs(f), Math.abs(h)) / Math.PI, i.isScrolling = s.isHorizontal() ? e > r.touchAngle : 90 - e > r.touchAngle);
  }
  if (i.isScrolling && s.emit("touchMoveOpposite", l), void 0 === i.startMoving && (n.currentX === n.startX && n.currentY === n.startY || (i.startMoving = !0)), i.isScrolling) return void (i.isTouched = !1);
  if (!i.startMoving) return;
  s.allowClick = !1, !r.cssMode && l.cancelable && l.preventDefault(), r.touchMoveStopPropagation && !r.nested && l.stopPropagation(), i.isMoved || (r.loop && !r.cssMode && s.loopFix(), i.startTranslate = s.getTranslate(), s.setTransition(0), s.animating && s.$wrapperEl.trigger("webkitTransitionEnd transitionend"), i.allowMomentumBounce = !1, !r.grabCursor || !0 !== s.allowSlideNext && !0 !== s.allowSlidePrev || s.setGrabCursor(!0), s.emit("sliderFirstMove", l)), s.emit("sliderMove", l), i.isMoved = !0;
  let m = s.isHorizontal() ? h : f;
  n.diff = m, m *= r.touchRatio, a && (m = -m), s.swipeDirection = m > 0 ? "prev" : "next", i.currentTranslate = m + i.startTranslate;
  let g = !0,
    w = r.resistanceRatio;
  if (r.touchReleaseOnEdges && (w = 0), m > 0 && i.currentTranslate > s.minTranslate() ? (g = !1, r.resistance && (i.currentTranslate = s.minTranslate() - 1 + (-s.minTranslate() + i.startTranslate + m) ** w)) : m < 0 && i.currentTranslate < s.maxTranslate() && (g = !1, r.resistance && (i.currentTranslate = s.maxTranslate() + 1 - (s.maxTranslate() - i.startTranslate - m) ** w)), g && (l.preventedByNestedSwiper = !0), !s.allowSlideNext && "next" === s.swipeDirection && i.currentTranslate < i.startTranslate && (i.currentTranslate = i.startTranslate), !s.allowSlidePrev && "prev" === s.swipeDirection && i.currentTranslate > i.startTranslate && (i.currentTranslate = i.startTranslate), s.allowSlidePrev || s.allowSlideNext || (i.currentTranslate = i.startTranslate), r.threshold > 0) {
    if (!(Math.abs(m) > r.threshold || i.allowThresholdMove)) return void (i.currentTranslate = i.startTranslate);
    if (!i.allowThresholdMove) return i.allowThresholdMove = !0, n.startX = n.currentX, n.startY = n.currentY, i.currentTranslate = i.startTranslate, void (n.diff = s.isHorizontal() ? n.currentX - n.startX : n.currentY - n.startY);
  }
  r.followFinger && !r.cssMode && ((r.freeMode && r.freeMode.enabled && s.freeMode || r.watchSlidesProgress) && (s.updateActiveIndex(), s.updateSlidesClasses()), s.params.freeMode && r.freeMode.enabled && s.freeMode && s.freeMode.onTouchMove(), s.updateProgress(i.currentTranslate), s.setTranslate(i.currentTranslate));
}
function j(e) {
  const t = this,
    s = t.touchEventsData,
    {
      params: i,
      touches: r,
      rtlTranslate: n,
      slidesGrid: a,
      enabled: o
    } = t;
  if (!o) return;
  let l = e;
  if (l.originalEvent && (l = l.originalEvent), s.allowTouchCallbacks && t.emit("touchEnd", l), s.allowTouchCallbacks = !1, !s.isTouched) return s.isMoved && i.grabCursor && t.setGrabCursor(!1), s.isMoved = !1, void (s.startMoving = !1);
  i.grabCursor && s.isMoved && s.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
  const d = b(),
    c = d - s.touchStartTime;
  if (t.allowClick) {
    const e = l.path || l.composedPath && l.composedPath();
    t.updateClickedSlide(e && e[0] || l.target), t.emit("tap click", l), c < 300 && d - s.lastClickTime < 300 && t.emit("doubleTap doubleClick", l);
  }
  if (s.lastClickTime = b(), A(() => {
    t.destroyed || (t.allowClick = !0);
  }), !s.isTouched || !s.isMoved || !t.swipeDirection || 0 === r.diff || s.currentTranslate === s.startTranslate) return s.isTouched = !1, s.isMoved = !1, void (s.startMoving = !1);
  let p;
  if (s.isTouched = !1, s.isMoved = !1, s.startMoving = !1, p = i.followFinger ? n ? t.translate : -t.translate : -s.currentTranslate, i.cssMode) return;
  if (t.params.freeMode && i.freeMode.enabled) return void t.freeMode.onTouchEnd({
    currentPos: p
  });
  let u = 0,
    h = t.slidesSizesGrid[0];
  for (let e = 0; e < a.length; e += e < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup) {
    const t = e < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
    void 0 !== a[e + t] ? p >= a[e] && p < a[e + t] && (u = e, h = a[e + t] - a[e]) : p >= a[e] && (u = e, h = a[a.length - 1] - a[a.length - 2]);
  }
  let f = null,
    m = null;
  i.rewind && (t.isBeginning ? m = t.params.virtual && t.params.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (f = 0));
  const g = (p - a[u]) / h,
    v = u < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
  if (c > i.longSwipesMs) {
    if (!i.longSwipes) return void t.slideTo(t.activeIndex);
    "next" === t.swipeDirection && (g >= i.longSwipesRatio ? t.slideTo(i.rewind && t.isEnd ? f : u + v) : t.slideTo(u)), "prev" === t.swipeDirection && (g > 1 - i.longSwipesRatio ? t.slideTo(u + v) : null !== m && g < 0 && Math.abs(g) > i.longSwipesRatio ? t.slideTo(m) : t.slideTo(u));
  } else {
    if (!i.shortSwipes) return void t.slideTo(t.activeIndex);
    t.navigation && (l.target === t.navigation.nextEl || l.target === t.navigation.prevEl) ? l.target === t.navigation.nextEl ? t.slideTo(u + v) : t.slideTo(u) : ("next" === t.swipeDirection && t.slideTo(null !== f ? f : u + v), "prev" === t.swipeDirection && t.slideTo(null !== m ? m : u));
  }
}
function Y() {
  const e = this,
    {
      params: t,
      el: s
    } = e;
  if (s && 0 === s.offsetWidth) return;
  t.breakpoints && e.setBreakpoint();
  const {
    allowSlideNext: i,
    allowSlidePrev: r,
    snapGrid: n
  } = e;
  e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses(), ("auto" === t.slidesPerView || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(), e.allowSlidePrev = r, e.allowSlideNext = i, e.params.watchOverflow && n !== e.snapGrid && e.checkOverflow();
}
function F(e) {
  const t = this;
  t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function H() {
  const e = this,
    {
      wrapperEl: t,
      rtlTranslate: s,
      enabled: i
    } = e;
  if (!i) return;
  let r;
  e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, 0 === e.translate && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
  const n = e.maxTranslate() - e.minTranslate();
  r = 0 === n ? 0 : (e.translate - e.minTranslate()) / n, r !== e.progress && e.updateProgress(s ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
}
let V = !1;
function R() {}
const W = (e, t) => {
  const s = p(),
    {
      params: i,
      touchEvents: r,
      el: n,
      wrapperEl: a,
      device: o,
      support: l
    } = e,
    d = !!i.nested,
    c = "on" === t ? "addEventListener" : "removeEventListener",
    u = t;
  if (l.touch) {
    const t = !("touchstart" !== r.start || !l.passiveListener || !i.passiveListeners) && {
      passive: !0,
      capture: !1
    };
    n[c](r.start, e.onTouchStart, t), n[c](r.move, e.onTouchMove, l.passiveListener ? {
      passive: !1,
      capture: d
    } : d), n[c](r.end, e.onTouchEnd, t), r.cancel && n[c](r.cancel, e.onTouchEnd, t);
  } else n[c](r.start, e.onTouchStart, !1), s[c](r.move, e.onTouchMove, d), s[c](r.end, e.onTouchEnd, !1);
  (i.preventClicks || i.preventClicksPropagation) && n[c]("click", e.onClick, !0), i.cssMode && a[c]("scroll", e.onScroll), i.updateOnWindowResize ? e[u](o.ios || o.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Y, !0) : e[u]("observerUpdate", Y, !0);
};
var q = {
  attachEvents: function () {
    const e = this,
      t = p(),
      {
        params: s,
        support: i
      } = e;
    e.onTouchStart = I.bind(e), e.onTouchMove = N.bind(e), e.onTouchEnd = j.bind(e), s.cssMode && (e.onScroll = H.bind(e)), e.onClick = F.bind(e), i.touch && !V && (t.addEventListener("touchstart", R), V = !0), W(e, "on");
  },
  detachEvents: function () {
    W(this, "off");
  }
};
const X = (e, t) => e.grid && t.grid && t.grid.rows > 1;
var Q = {
  addClasses: function () {
    const e = this,
      {
        classNames: t,
        params: s,
        rtl: i,
        $el: r,
        device: n,
        support: a
      } = e,
      o = function (e, t) {
        const s = [];
        return e.forEach(e => {
          "object" == typeof e ? Object.keys(e).forEach(i => {
            e[i] && s.push(t + i);
          }) : "string" == typeof e && s.push(t + e);
        }), s;
      }(["initialized", s.direction, {
        "pointer-events": !a.touch
      }, {
        "free-mode": e.params.freeMode && s.freeMode.enabled
      }, {
        autoheight: s.autoHeight
      }, {
        rtl: i
      }, {
        grid: s.grid && s.grid.rows > 1
      }, {
        "grid-column": s.grid && s.grid.rows > 1 && "column" === s.grid.fill
      }, {
        android: n.android
      }, {
        ios: n.ios
      }, {
        "css-mode": s.cssMode
      }, {
        centered: s.cssMode && s.centeredSlides
      }, {
        "watch-progress": s.watchSlidesProgress
      }], s.containerModifierClass);
    t.push(...o), r.addClass([...t].join(" ")), e.emitContainerClasses();
  },
  removeClasses: function () {
    const {
      $el: e,
      classNames: t
    } = this;
    e.removeClass(t.join(" ")), this.emitContainerClasses();
  }
};
var Z = {
  init: !0,
  direction: "horizontal",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  width: null,
  height: null,
  preventInteractionOnTransition: !1,
  userAgent: null,
  url: null,
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  autoHeight: !1,
  setWrapperSize: !1,
  virtualTranslate: !1,
  effect: "slide",
  breakpoints: void 0,
  breakpointsBase: "window",
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  watchOverflow: !0,
  roundLengths: !1,
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: .5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 0,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  uniqueNavElements: !0,
  resistance: !0,
  resistanceRatio: .85,
  watchSlidesProgress: !1,
  grabCursor: !1,
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  preloadImages: !0,
  updateOnImagesReady: !0,
  loop: !1,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopedSlidesLimit: !0,
  loopFillGroupWithBlank: !1,
  loopPreventsSlide: !0,
  rewind: !1,
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  containerModifierClass: "swiper-",
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-invisible-blank",
  slideActiveClass: "swiper-slide-active",
  slideDuplicateActiveClass: "swiper-slide-duplicate-active",
  slideVisibleClass: "swiper-slide-visible",
  slideDuplicateClass: "swiper-slide-duplicate",
  slideNextClass: "swiper-slide-next",
  slideDuplicateNextClass: "swiper-slide-duplicate-next",
  slidePrevClass: "swiper-slide-prev",
  slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
  wrapperClass: "swiper-wrapper",
  runCallbacksOnInit: !0,
  _emitClasses: !1
};
function U(e, t) {
  return function (s = {}) {
    const i = Object.keys(s)[0],
      r = s[i];
    "object" == typeof r && null !== r ? (["navigation", "pagination", "scrollbar"].indexOf(i) >= 0 && !0 === e[i] && (e[i] = {
      auto: !0
    }), i in e && "enabled" in r ? (!0 === e[i] && (e[i] = {
      enabled: !0
    }), "object" != typeof e[i] || "enabled" in e[i] || (e[i].enabled = !0), e[i] || (e[i] = {
      enabled: !1
    }), E(t, s)) : E(t, s)) : E(t, s);
  };
}
const K = {
    eventsEmitter: B,
    update: z,
    translate: G,
    transition: {
      setTransition: function (e, t) {
        const s = this;
        s.params.cssMode || s.$wrapperEl.transition(e), s.emit("setTransition", e, t);
      },
      transitionStart: function (e = !0, t) {
        const s = this,
          {
            params: i
          } = s;
        i.cssMode || (i.autoHeight && s.updateAutoHeight(), $({
          swiper: s,
          runCallbacks: e,
          direction: t,
          step: "Start"
        }));
      },
      transitionEnd: function (e = !0, t) {
        const s = this,
          {
            params: i
          } = s;
        s.animating = !1, i.cssMode || (s.setTransition(0), $({
          swiper: s,
          runCallbacks: e,
          direction: t,
          step: "End"
        }));
      }
    },
    slide: _,
    loop: D,
    grabCursor: {
      setGrabCursor: function (e) {
        const t = this;
        if (t.support.touch || !t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode) return;
        const s = "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
        s.style.cursor = "move", s.style.cursor = e ? "grabbing" : "grab";
      },
      unsetGrabCursor: function () {
        const e = this;
        e.support.touch || e.params.watchOverflow && e.isLocked || e.params.cssMode || (e["container" === e.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = "");
      }
    },
    events: q,
    breakpoints: {
      setBreakpoint: function () {
        const e = this,
          {
            activeIndex: t,
            initialized: s,
            loopedSlides: i = 0,
            params: r,
            $el: n
          } = e,
          a = r.breakpoints;
        if (!a || a && 0 === Object.keys(a).length) return;
        const o = e.getBreakpoint(a, e.params.breakpointsBase, e.el);
        if (!o || e.currentBreakpoint === o) return;
        const l = (o in a ? a[o] : void 0) || e.originalParams,
          d = X(e, r),
          c = X(e, l),
          p = r.enabled;
        d && !c ? (n.removeClass(`${r.containerModifierClass}grid ${r.containerModifierClass}grid-column`), e.emitContainerClasses()) : !d && c && (n.addClass(`${r.containerModifierClass}grid`), (l.grid.fill && "column" === l.grid.fill || !l.grid.fill && "column" === r.grid.fill) && n.addClass(`${r.containerModifierClass}grid-column`), e.emitContainerClasses()), ["navigation", "pagination", "scrollbar"].forEach(t => {
          const s = r[t] && r[t].enabled,
            i = l[t] && l[t].enabled;
          s && !i && e[t].disable(), !s && i && e[t].enable();
        });
        const u = l.direction && l.direction !== r.direction,
          h = r.loop && (l.slidesPerView !== r.slidesPerView || u);
        u && s && e.changeDirection(), E(e.params, l);
        const f = e.params.enabled;
        Object.assign(e, {
          allowTouchMove: e.params.allowTouchMove,
          allowSlideNext: e.params.allowSlideNext,
          allowSlidePrev: e.params.allowSlidePrev
        }), p && !f ? e.disable() : !p && f && e.enable(), e.currentBreakpoint = o, e.emit("_beforeBreakpoint", l), h && s && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(t - i + e.loopedSlides, 0, !1)), e.emit("breakpoint", l);
      },
      getBreakpoint: function (e, t = "window", s) {
        if (!e || "container" === t && !s) return;
        let i = !1;
        const r = h(),
          n = "window" === t ? r.innerHeight : s.clientHeight,
          a = Object.keys(e).map(e => {
            if ("string" == typeof e && 0 === e.indexOf("@")) {
              const t = parseFloat(e.substr(1));
              return {
                value: n * t,
                point: e
              };
            }
            return {
              value: e,
              point: e
            };
          });
        a.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
        for (let e = 0; e < a.length; e += 1) {
          const {
            point: n,
            value: o
          } = a[e];
          "window" === t ? r.matchMedia(`(min-width: ${o}px)`).matches && (i = n) : o <= s.clientWidth && (i = n);
        }
        return i || "max";
      }
    },
    checkOverflow: {
      checkOverflow: function () {
        const e = this,
          {
            isLocked: t,
            params: s
          } = e,
          {
            slidesOffsetBefore: i
          } = s;
        if (i) {
          const t = e.slides.length - 1,
            s = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * i;
          e.isLocked = e.size > s;
        } else e.isLocked = 1 === e.snapGrid.length;
        !0 === s.allowSlideNext && (e.allowSlideNext = !e.isLocked), !0 === s.allowSlidePrev && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
      }
    },
    classes: Q,
    images: {
      loadImage: function (e, t, s, i, r, n) {
        const a = h();
        let o;
        function l() {
          n && n();
        }
        v(e).parent("picture")[0] || e.complete && r ? l() : t ? (o = new a.Image(), o.onload = l, o.onerror = l, i && (o.sizes = i), s && (o.srcset = s), t && (o.src = t)) : l();
      },
      preloadImages: function () {
        const e = this;
        function t() {
          null != e && e && !e.destroyed && (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")));
        }
        e.imagesToLoad = e.$el.find("img");
        for (let s = 0; s < e.imagesToLoad.length; s += 1) {
          const i = e.imagesToLoad[s];
          e.loadImage(i, i.currentSrc || i.getAttribute("src"), i.srcset || i.getAttribute("srcset"), i.sizes || i.getAttribute("sizes"), !0, t);
        }
      }
    }
  },
  J = {};
class ee {
  constructor(...e) {
    let t, s;
    if (1 === e.length && e[0].constructor && "Object" === Object.prototype.toString.call(e[0]).slice(8, -1) ? s = e[0] : [t, s] = e, s || (s = {}), s = E({}, s), t && !s.el && (s.el = t), s.el && v(s.el).length > 1) {
      const e = [];
      return v(s.el).each(t => {
        const i = E({}, s, {
          el: t
        });
        e.push(new ee(i));
      }), e;
    }
    const i = this;
    i.__swiper__ = !0, i.support = k(), i.device = O({
      userAgent: s.userAgent
    }), i.browser = L(), i.eventsListeners = {}, i.eventsAnyListeners = [], i.modules = [...i.__modules__], s.modules && Array.isArray(s.modules) && i.modules.push(...s.modules);
    const r = {};
    i.modules.forEach(e => {
      e({
        swiper: i,
        extendParams: U(s, r),
        on: i.on.bind(i),
        once: i.once.bind(i),
        off: i.off.bind(i),
        emit: i.emit.bind(i)
      });
    });
    const n = E({}, Z, r);
    return i.params = E({}, n, J, s), i.originalParams = E({}, i.params), i.passedParams = E({}, s), i.params && i.params.on && Object.keys(i.params.on).forEach(e => {
      i.on(e, i.params.on[e]);
    }), i.params && i.params.onAny && i.onAny(i.params.onAny), i.$ = v, Object.assign(i, {
      enabled: i.params.enabled,
      el: t,
      classNames: [],
      slides: v(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      isHorizontal: () => "horizontal" === i.params.direction,
      isVertical: () => "vertical" === i.params.direction,
      activeIndex: 0,
      realIndex: 0,
      isBeginning: !0,
      isEnd: !1,
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      allowSlideNext: i.params.allowSlideNext,
      allowSlidePrev: i.params.allowSlidePrev,
      touchEvents: function () {
        const e = ["touchstart", "touchmove", "touchend", "touchcancel"],
          t = ["pointerdown", "pointermove", "pointerup"];
        return i.touchEventsTouch = {
          start: e[0],
          move: e[1],
          end: e[2],
          cancel: e[3]
        }, i.touchEventsDesktop = {
          start: t[0],
          move: t[1],
          end: t[2]
        }, i.support.touch || !i.params.simulateTouch ? i.touchEventsTouch : i.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        focusableElements: i.params.focusableElements,
        lastClickTime: b(),
        clickTimeout: void 0,
        velocities: [],
        allowMomentumBounce: void 0,
        isTouchEvent: void 0,
        startMoving: void 0
      },
      allowClick: !0,
      allowTouchMove: i.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      imagesToLoad: [],
      imagesLoaded: 0
    }), i.emit("_swiper"), i.params.init && i.init(), i;
  }
  enable() {
    const e = this;
    e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
  }
  disable() {
    const e = this;
    e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
  }
  setProgress(e, t) {
    const s = this;
    e = Math.min(Math.max(e, 0), 1);
    const i = s.minTranslate(),
      r = (s.maxTranslate() - i) * e + i;
    s.translateTo(r, void 0 === t ? 0 : t), s.updateActiveIndex(), s.updateSlidesClasses();
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const t = e.el.className.split(" ").filter(t => 0 === t.indexOf("swiper") || 0 === t.indexOf(e.params.containerModifierClass));
    e.emit("_containerClasses", t.join(" "));
  }
  getSlideClasses(e) {
    const t = this;
    return t.destroyed ? "" : e.className.split(" ").filter(e => 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass)).join(" ");
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const t = [];
    e.slides.each(s => {
      const i = e.getSlideClasses(s);
      t.push({
        slideEl: s,
        classNames: i
      }), e.emit("_slideClass", s, i);
    }), e.emit("_slideClasses", t);
  }
  slidesPerViewDynamic(e = "current", t = !1) {
    const {
      params: s,
      slides: i,
      slidesGrid: r,
      slidesSizesGrid: n,
      size: a,
      activeIndex: o
    } = this;
    let l = 1;
    if (s.centeredSlides) {
      let e,
        t = i[o].swiperSlideSize;
      for (let s = o + 1; s < i.length; s += 1) i[s] && !e && (t += i[s].swiperSlideSize, l += 1, t > a && (e = !0));
      for (let s = o - 1; s >= 0; s -= 1) i[s] && !e && (t += i[s].swiperSlideSize, l += 1, t > a && (e = !0));
    } else if ("current" === e) for (let e = o + 1; e < i.length; e += 1) {
      (t ? r[e] + n[e] - r[o] < a : r[e] - r[o] < a) && (l += 1);
    } else for (let e = o - 1; e >= 0; e -= 1) {
      r[o] - r[e] < a && (l += 1);
    }
    return l;
  }
  update() {
    const e = this;
    if (!e || e.destroyed) return;
    const {
      snapGrid: t,
      params: s
    } = e;
    function i() {
      const t = e.rtlTranslate ? -1 * e.translate : e.translate,
        s = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
      e.setTranslate(s), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    let r;
    s.breakpoints && e.setBreakpoint(), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.params.freeMode && e.params.freeMode.enabled ? (i(), e.params.autoHeight && e.updateAutoHeight()) : (r = ("auto" === e.params.slidesPerView || e.params.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), r || i()), s.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update");
  }
  changeDirection(e, t = !0) {
    const s = this,
      i = s.params.direction;
    return e || (e = "horizontal" === i ? "vertical" : "horizontal"), e === i || "horizontal" !== e && "vertical" !== e || (s.$el.removeClass(`${s.params.containerModifierClass}${i}`).addClass(`${s.params.containerModifierClass}${e}`), s.emitContainerClasses(), s.params.direction = e, s.slides.each(t => {
      "vertical" === e ? t.style.width = "" : t.style.height = "";
    }), s.emit("changeDirection"), t && s.update()), s;
  }
  changeLanguageDirection(e) {
    const t = this;
    t.rtl && "rtl" === e || !t.rtl && "ltr" === e || (t.rtl = "rtl" === e, t.rtlTranslate = "horizontal" === t.params.direction && t.rtl, t.rtl ? (t.$el.addClass(`${t.params.containerModifierClass}rtl`), t.el.dir = "rtl") : (t.$el.removeClass(`${t.params.containerModifierClass}rtl`), t.el.dir = "ltr"), t.update());
  }
  mount(e) {
    const t = this;
    if (t.mounted) return !0;
    const s = v(e || t.params.el);
    if (!(e = s[0])) return !1;
    e.swiper = t;
    const i = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let r = (() => {
      if (e && e.shadowRoot && e.shadowRoot.querySelector) {
        const t = v(e.shadowRoot.querySelector(i()));
        return t.children = e => s.children(e), t;
      }
      return s.children ? s.children(i()) : v(s).children(i());
    })();
    if (0 === r.length && t.params.createElements) {
      const e = p().createElement("div");
      r = v(e), e.className = t.params.wrapperClass, s.append(e), s.children(`.${t.params.slideClass}`).each(e => {
        r.append(e);
      });
    }
    return Object.assign(t, {
      $el: s,
      el: e,
      $wrapperEl: r,
      wrapperEl: r[0],
      mounted: !0,
      rtl: "rtl" === e.dir.toLowerCase() || "rtl" === s.css("direction"),
      rtlTranslate: "horizontal" === t.params.direction && ("rtl" === e.dir.toLowerCase() || "rtl" === s.css("direction")),
      wrongRTL: "-webkit-box" === r.css("display")
    }), !0;
  }
  init(e) {
    const t = this;
    if (t.initialized) return t;
    return !1 === t.mount(e) || (t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.params.loop && t.loopCreate(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.enabled && t.setGrabCursor(), t.params.preloadImages && t.preloadImages(), t.params.loop ? t.slideTo(t.params.initialSlide + t.loopedSlides, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0), t.attachEvents(), t.initialized = !0, t.emit("init"), t.emit("afterInit")), t;
  }
  destroy(e = !0, t = !0) {
    const s = this,
      {
        params: i,
        $el: r,
        $wrapperEl: n,
        slides: a
      } = s;
    return void 0 === s.params || s.destroyed || (s.emit("beforeDestroy"), s.initialized = !1, s.detachEvents(), i.loop && s.loopDestroy(), t && (s.removeClasses(), r.removeAttr("style"), n.removeAttr("style"), a && a.length && a.removeClass([i.slideVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")), s.emit("destroy"), Object.keys(s.eventsListeners).forEach(e => {
      s.off(e);
    }), !1 !== e && (s.$el[0].swiper = null, function (e) {
      const t = e;
      Object.keys(t).forEach(e => {
        try {
          t[e] = null;
        } catch (e) {}
        try {
          delete t[e];
        } catch (e) {}
      });
    }(s)), s.destroyed = !0), null;
  }
  static extendDefaults(e) {
    E(J, e);
  }
  static get extendedDefaults() {
    return J;
  }
  static get defaults() {
    return Z;
  }
  static installModule(e) {
    ee.prototype.__modules__ || (ee.prototype.__modules__ = []);
    const t = ee.prototype.__modules__;
    "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
  }
  static use(e) {
    return Array.isArray(e) ? (e.forEach(e => ee.installModule(e)), ee) : (ee.installModule(e), ee);
  }
}
function te(e) {
  return "object" == typeof e && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1);
}
function se(e, t) {
  const s = ["__proto__", "constructor", "prototype"];
  Object.keys(t).filter(e => s.indexOf(e) < 0).forEach(s => {
    void 0 === e[s] ? e[s] = t[s] : te(t[s]) && te(e[s]) && Object.keys(t[s]).length > 0 ? t[s].__swiper__ ? e[s] = t[s] : se(e[s], t[s]) : e[s] = t[s];
  });
}
function ie(e = {}) {
  return e.navigation && void 0 === e.navigation.nextEl && void 0 === e.navigation.prevEl;
}
function re(e = {}) {
  return e.pagination && void 0 === e.pagination.el;
}
function ne(e = {}) {
  return e.scrollbar && void 0 === e.scrollbar.el;
}
function ae(e = "") {
  const t = e.split(" ").map(e => e.trim()).filter(e => !!e),
    s = [];
  return t.forEach(e => {
    s.indexOf(e) < 0 && s.push(e);
  }), s.join(" ");
}
Object.keys(K).forEach(e => {
  Object.keys(K[e]).forEach(t => {
    ee.prototype[t] = K[e][t];
  });
}), ee.use([function ({
  swiper: e,
  on: t,
  emit: s
}) {
  const i = h();
  let r = null,
    n = null;
  const a = () => {
      e && !e.destroyed && e.initialized && (s("beforeResize"), s("resize"));
    },
    o = () => {
      e && !e.destroyed && e.initialized && s("orientationchange");
    };
  t("init", () => {
    e.params.resizeObserver && void 0 !== i.ResizeObserver ? e && !e.destroyed && e.initialized && (r = new ResizeObserver(t => {
      n = i.requestAnimationFrame(() => {
        const {
          width: s,
          height: i
        } = e;
        let r = s,
          n = i;
        t.forEach(({
          contentBoxSize: t,
          contentRect: s,
          target: i
        }) => {
          i && i !== e.el || (r = s ? s.width : (t[0] || t).inlineSize, n = s ? s.height : (t[0] || t).blockSize);
        }), r === s && n === i || a();
      });
    }), r.observe(e.el)) : (i.addEventListener("resize", a), i.addEventListener("orientationchange", o));
  }), t("destroy", () => {
    n && i.cancelAnimationFrame(n), r && r.unobserve && e.el && (r.unobserve(e.el), r = null), i.removeEventListener("resize", a), i.removeEventListener("orientationchange", o);
  });
}, function ({
  swiper: e,
  extendParams: t,
  on: s,
  emit: i
}) {
  const r = [],
    n = h(),
    a = (e, t = {}) => {
      const s = new (n.MutationObserver || n.WebkitMutationObserver)(e => {
        if (1 === e.length) return void i("observerUpdate", e[0]);
        const t = function () {
          i("observerUpdate", e[0]);
        };
        n.requestAnimationFrame ? n.requestAnimationFrame(t) : n.setTimeout(t, 0);
      });
      s.observe(e, {
        attributes: void 0 === t.attributes || t.attributes,
        childList: void 0 === t.childList || t.childList,
        characterData: void 0 === t.characterData || t.characterData
      }), r.push(s);
    };
  t({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), s("init", () => {
    if (e.params.observer) {
      if (e.params.observeParents) {
        const t = e.$el.parents();
        for (let e = 0; e < t.length; e += 1) a(t[e]);
      }
      a(e.$el[0], {
        childList: e.params.observeSlideChildren
      }), a(e.$wrapperEl[0], {
        attributes: !1
      });
    }
  }), s("destroy", () => {
    r.forEach(e => {
      e.disconnect();
    }), r.splice(0, r.length);
  });
}]);
const oe = ["modules", "init", "_direction", "touchEventsTarget", "initialSlide", "_speed", "cssMode", "updateOnWindowResize", "resizeObserver", "nested", "focusableElements", "_enabled", "_width", "_height", "preventInteractionOnTransition", "userAgent", "url", "_edgeSwipeDetection", "_edgeSwipeThreshold", "_freeMode", "_autoHeight", "setWrapperSize", "virtualTranslate", "_effect", "breakpoints", "_spaceBetween", "_slidesPerView", "maxBackfaceHiddenSlides", "_grid", "_slidesPerGroup", "_slidesPerGroupSkip", "_slidesPerGroupAuto", "_centeredSlides", "_centeredSlidesBounds", "_slidesOffsetBefore", "_slidesOffsetAfter", "normalizeSlideIndex", "_centerInsufficientSlides", "_watchOverflow", "roundLengths", "touchRatio", "touchAngle", "simulateTouch", "_shortSwipes", "_longSwipes", "longSwipesRatio", "longSwipesMs", "_followFinger", "allowTouchMove", "_threshold", "touchMoveStopPropagation", "touchStartPreventDefault", "touchStartForcePreventDefault", "touchReleaseOnEdges", "uniqueNavElements", "_resistance", "_resistanceRatio", "_watchSlidesProgress", "_grabCursor", "preventClicks", "preventClicksPropagation", "_slideToClickedSlide", "_preloadImages", "updateOnImagesReady", "_loop", "_loopAdditionalSlides", "_loopedSlides", "_loopedSlidesLimit", "_loopFillGroupWithBlank", "loopPreventsSlide", "_rewind", "_allowSlidePrev", "_allowSlideNext", "_swipeHandler", "_noSwiping", "noSwipingClass", "noSwipingSelector", "passiveListeners", "containerModifierClass", "slideClass", "slideBlankClass", "slideActiveClass", "slideDuplicateActiveClass", "slideVisibleClass", "slideDuplicateClass", "slideNextClass", "slideDuplicateNextClass", "slidePrevClass", "slideDuplicatePrevClass", "wrapperClass", "runCallbacksOnInit", "observer", "observeParents", "observeSlideChildren", "a11y", "_autoplay", "_controller", "coverflowEffect", "cubeEffect", "fadeEffect", "flipEffect", "creativeEffect", "cardsEffect", "hashNavigation", "history", "keyboard", "lazy", "mousewheel", "_navigation", "_pagination", "parallax", "_scrollbar", "_thumbs", "virtual", "zoom"];
const le = (e, t) => {
  let s = t.slidesPerView;
  if (t.breakpoints) {
    const e = ee.prototype.getBreakpoint(t.breakpoints),
      i = e in t.breakpoints ? t.breakpoints[e] : void 0;
    i && i.slidesPerView && (s = i.slidesPerView);
  }
  let i = Math.ceil(parseFloat(t.loopedSlides || s, 10));
  return i += t.loopAdditionalSlides, i > e.length && t.loopedSlidesLimit && (i = e.length), i;
};
function de(e) {
  return e.type && e.type.displayName && e.type.displayName.includes("SwiperSlide");
}
function ce(t) {
  const s = [];
  return e.Children.toArray(t).forEach(e => {
    de(e) ? s.push(e) : e.props && e.props.children && ce(e.props.children).forEach(e => s.push(e));
  }), s;
}
function pe(t) {
  const s = [],
    i = {
      "container-start": [],
      "container-end": [],
      "wrapper-start": [],
      "wrapper-end": []
    };
  return e.Children.toArray(t).forEach(e => {
    if (de(e)) s.push(e);else if (e.props && e.props.slot && i[e.props.slot]) i[e.props.slot].push(e);else if (e.props && e.props.children) {
      const t = ce(e.props.children);
      t.length > 0 ? t.forEach(e => s.push(e)) : i["container-end"].push(e);
    } else i["container-end"].push(e);
  }), {
    slides: s,
    slots: i
  };
}
function ue({
  swiper: e,
  slides: t,
  passedParams: s,
  changedParams: i,
  nextEl: r,
  prevEl: n,
  scrollbarEl: a,
  paginationEl: o
}) {
  const l = i.filter(e => "children" !== e && "direction" !== e),
    {
      params: d,
      pagination: c,
      navigation: p,
      scrollbar: u,
      virtual: h,
      thumbs: f
    } = e;
  let m, g, v, w, A;
  i.includes("thumbs") && s.thumbs && s.thumbs.swiper && d.thumbs && !d.thumbs.swiper && (m = !0), i.includes("controller") && s.controller && s.controller.control && d.controller && !d.controller.control && (g = !0), i.includes("pagination") && s.pagination && (s.pagination.el || o) && (d.pagination || !1 === d.pagination) && c && !c.el && (v = !0), i.includes("scrollbar") && s.scrollbar && (s.scrollbar.el || a) && (d.scrollbar || !1 === d.scrollbar) && u && !u.el && (w = !0), i.includes("navigation") && s.navigation && (s.navigation.prevEl || n) && (s.navigation.nextEl || r) && (d.navigation || !1 === d.navigation) && p && !p.prevEl && !p.nextEl && (A = !0);
  if (l.forEach(t => {
    if (te(d[t]) && te(s[t])) se(d[t], s[t]);else {
      const r = s[t];
      !0 !== r && !1 !== r || "navigation" !== t && "pagination" !== t && "scrollbar" !== t ? d[t] = s[t] : !1 === r && e[i = t] && (e[i].destroy(), "navigation" === i ? (d[i].prevEl = void 0, d[i].nextEl = void 0, e[i].prevEl = void 0, e[i].nextEl = void 0) : (d[i].el = void 0, e[i].el = void 0));
    }
    var i;
  }), l.includes("controller") && !g && e.controller && e.controller.control && d.controller && d.controller.control && (e.controller.control = d.controller.control), i.includes("children") && t && h && d.virtual.enabled ? (h.slides = t, h.update(!0)) : i.includes("children") && e.lazy && e.params.lazy.enabled && e.lazy.load(), m) {
    f.init() && f.update(!0);
  }
  g && (e.controller.control = d.controller.control), v && (o && (d.pagination.el = o), c.init(), c.render(), c.update()), w && (a && (d.scrollbar.el = a), u.init(), u.updateSize(), u.setTranslate()), A && (r && (d.navigation.nextEl = r), n && (d.navigation.prevEl = n), p.init(), p.update()), i.includes("allowSlideNext") && (e.allowSlideNext = s.allowSlideNext), i.includes("allowSlidePrev") && (e.allowSlidePrev = s.allowSlidePrev), i.includes("direction") && e.changeDirection(s.direction, !1), e.update();
}
function he(e, i) {
  return "undefined" == typeof window ? t(e, i) : s(e, i);
}
const fe = i(null),
  me = i(null);
function ge() {
  return ge = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var s = arguments[t];
      for (var i in s) Object.prototype.hasOwnProperty.call(s, i) && (e[i] = s[i]);
    }
    return e;
  }, ge.apply(this, arguments);
}
const ve = r(function (s, i) {
  let {
      className: r,
      tag: o = "div",
      wrapperTag: l = "div",
      children: d,
      onSwiper: c,
      ...p
    } = void 0 === s ? {} : s,
    u = !1;
  const [h, f] = n("swiper"),
    [m, g] = n(null),
    [v, w] = n(!1),
    A = a(!1),
    b = a(null),
    S = a(null),
    T = a(null),
    E = a(null),
    x = a(null),
    y = a(null),
    C = a(null),
    P = a(null),
    {
      params: M,
      passedParams: k,
      rest: O,
      events: L
    } = function (e = {}, t = !0) {
      const s = {
          on: {}
        },
        i = {},
        r = {};
      se(s, ee.defaults), se(s, ee.extendedDefaults), s._emitClasses = !0, s.init = !1;
      const n = {},
        a = oe.map(e => e.replace(/_/, "")),
        o = Object.assign({}, e);
      return Object.keys(o).forEach(o => {
        void 0 !== e[o] && (a.indexOf(o) >= 0 ? te(e[o]) ? (s[o] = {}, r[o] = {}, se(s[o], e[o]), se(r[o], e[o])) : (s[o] = e[o], r[o] = e[o]) : 0 === o.search(/on[A-Z]/) && "function" == typeof e[o] ? t ? i[`${o[2].toLowerCase()}${o.substr(3)}`] = e[o] : s.on[`${o[2].toLowerCase()}${o.substr(3)}`] = e[o] : n[o] = e[o]);
      }), ["navigation", "pagination", "scrollbar"].forEach(e => {
        !0 === s[e] && (s[e] = {}), !1 === s[e] && delete s[e];
      }), {
        params: s,
        passedParams: r,
        rest: n,
        events: i
      };
    }(p),
    {
      slides: B,
      slots: z
    } = pe(d),
    G = () => {
      w(!v);
    };
  Object.assign(M.on, {
    _containerClasses(e, t) {
      f(t);
    }
  });
  const $ = () => {
    if (Object.assign(M.on, L), u = !0, S.current = new ee(M), S.current.loopCreate = () => {}, S.current.loopDestroy = () => {}, M.loop && (S.current.loopedSlides = le(B, M)), S.current.virtual && S.current.params.virtual.enabled) {
      S.current.virtual.slides = B;
      const e = {
        cache: !1,
        slides: B,
        renderExternal: g,
        renderExternalUpdate: !1
      };
      se(S.current.params.virtual, e), se(S.current.originalParams.virtual, e);
    }
  };
  b.current || $(), S.current && S.current.on("_beforeBreakpoint", G);
  return t(() => () => {
    S.current && S.current.off("_beforeBreakpoint", G);
  }), t(() => {
    !A.current && S.current && (S.current.emitSlidesClasses(), A.current = !0);
  }), he(() => {
    if (i && (i.current = b.current), b.current) return S.current.destroyed && $(), function ({
      el: e,
      nextEl: t,
      prevEl: s,
      paginationEl: i,
      scrollbarEl: r,
      swiper: n
    }, a) {
      ie(a) && t && s && (n.params.navigation.nextEl = t, n.originalParams.navigation.nextEl = t, n.params.navigation.prevEl = s, n.originalParams.navigation.prevEl = s), re(a) && i && (n.params.pagination.el = i, n.originalParams.pagination.el = i), ne(a) && r && (n.params.scrollbar.el = r, n.originalParams.scrollbar.el = r), n.init(e);
    }({
      el: b.current,
      nextEl: x.current,
      prevEl: y.current,
      paginationEl: C.current,
      scrollbarEl: P.current,
      swiper: S.current
    }, M), c && c(S.current), () => {
      S.current && !S.current.destroyed && S.current.destroy(!0, !1);
    };
  }, []), he(() => {
    !u && L && S.current && Object.keys(L).forEach(e => {
      S.current.on(e, L[e]);
    });
    const e = function (e, t, s, i, r) {
      const n = [];
      if (!t) return n;
      const a = e => {
        n.indexOf(e) < 0 && n.push(e);
      };
      if (s && i) {
        const e = i.map(r),
          t = s.map(r);
        e.join("") !== t.join("") && a("children"), i.length !== s.length && a("children");
      }
      return oe.filter(e => "_" === e[0]).map(e => e.replace(/_/, "")).forEach(s => {
        if (s in e && s in t) if (te(e[s]) && te(t[s])) {
          const i = Object.keys(e[s]),
            r = Object.keys(t[s]);
          i.length !== r.length ? a(s) : (i.forEach(i => {
            e[s][i] !== t[s][i] && a(s);
          }), r.forEach(i => {
            e[s][i] !== t[s][i] && a(s);
          }));
        } else e[s] !== t[s] && a(s);
      }), n;
    }(k, T.current, B, E.current, e => e.key);
    return T.current = k, E.current = B, e.length && S.current && !S.current.destroyed && ue({
      swiper: S.current,
      slides: B,
      passedParams: k,
      changedParams: e,
      nextEl: x.current,
      prevEl: y.current,
      scrollbarEl: P.current,
      paginationEl: C.current
    }), () => {
      L && S.current && Object.keys(L).forEach(e => {
        S.current.off(e, L[e]);
      });
    };
  }), he(() => {
    var e;
    !(e = S.current) || e.destroyed || !e.params.virtual || e.params.virtual && !e.params.virtual.enabled || (e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.lazy && e.params.lazy.enabled && e.lazy.load(), e.parallax && e.params.parallax && e.params.parallax.enabled && e.parallax.setTranslate());
  }, [m]), e.createElement(o, ge({
    ref: b,
    className: ae(`${h}${r ? ` ${r}` : ""}`)
  }, O), e.createElement(me.Provider, {
    value: S.current
  }, z["container-start"], e.createElement(l, {
    className: "swiper-wrapper"
  }, z["wrapper-start"], M.virtual ? function (t, s, i) {
    if (!i) return null;
    const r = t.isHorizontal() ? {
      [t.rtlTranslate ? "right" : "left"]: `${i.offset}px`
    } : {
      top: `${i.offset}px`
    };
    return s.filter((e, t) => t >= i.from && t <= i.to).map(s => e.cloneElement(s, {
      swiper: t,
      style: r
    }));
  }(S.current, B, m) : !M.loop || S.current && S.current.destroyed ? B.map(t => e.cloneElement(t, {
    swiper: S.current
  })) : function (t, s, i) {
    const r = s.map((s, i) => e.cloneElement(s, {
      swiper: t,
      "data-swiper-slide-index": i
    }));
    function n(t, s, r) {
      return e.cloneElement(t, {
        key: `${t.key}-duplicate-${s}-${r}`,
        className: `${t.props.className || ""} ${i.slideDuplicateClass}`
      });
    }
    if (i.loopFillGroupWithBlank) {
      const t = i.slidesPerGroup - r.length % i.slidesPerGroup;
      if (t !== i.slidesPerGroup) for (let s = 0; s < t; s += 1) {
        const t = e.createElement("div", {
          className: `${i.slideClass} ${i.slideBlankClass}`
        });
        r.push(t);
      }
    }
    "auto" !== i.slidesPerView || i.loopedSlides || (i.loopedSlides = r.length);
    const a = le(r, i),
      o = [],
      l = [];
    for (let e = 0; e < a; e += 1) {
      const t = e - Math.floor(e / r.length) * r.length;
      l.push(n(r[t], e, "append")), o.unshift(n(r[r.length - t - 1], e, "prepend"));
    }
    return t && (t.loopedSlides = a), [...o, ...r, ...l];
  }(S.current, B, M), z["wrapper-end"]), ie(M) && e.createElement(e.Fragment, null, e.createElement("div", {
    ref: y,
    className: "swiper-button-prev"
  }), e.createElement("div", {
    ref: x,
    className: "swiper-button-next"
  })), ne(M) && e.createElement("div", {
    ref: P,
    className: "swiper-scrollbar"
  }), re(M) && e.createElement("div", {
    ref: C,
    className: "swiper-pagination"
  }), z["container-end"]));
});
function we() {
  return we = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var s = arguments[t];
      for (var i in s) Object.prototype.hasOwnProperty.call(s, i) && (e[i] = s[i]);
    }
    return e;
  }, we.apply(this, arguments);
}
ve.displayName = "Swiper";
const Ae = r(function (t, s) {
  let {
    tag: i = "div",
    children: r,
    className: o = "",
    swiper: l,
    zoom: d,
    virtualIndex: c,
    ...p
  } = void 0 === t ? {} : t;
  const u = a(null),
    [h, f] = n("swiper-slide");
  function m(e, t, s) {
    t === u.current && f(s);
  }
  he(() => {
    if (s && (s.current = u.current), u.current && l) {
      if (!l.destroyed) return l.on("_slideClass", m), () => {
        l && l.off("_slideClass", m);
      };
      "swiper-slide" !== h && f("swiper-slide");
    }
  }), he(() => {
    l && u.current && !l.destroyed && f(l.getSlideClasses(u.current));
  }, [l]);
  const g = {
      isActive: h.indexOf("swiper-slide-active") >= 0 || h.indexOf("swiper-slide-duplicate-active") >= 0,
      isVisible: h.indexOf("swiper-slide-visible") >= 0,
      isDuplicate: h.indexOf("swiper-slide-duplicate") >= 0,
      isPrev: h.indexOf("swiper-slide-prev") >= 0 || h.indexOf("swiper-slide-duplicate-prev") >= 0,
      isNext: h.indexOf("swiper-slide-next") >= 0 || h.indexOf("swiper-slide-duplicate-next") >= 0
    },
    v = () => "function" == typeof r ? r(g) : r;
  return e.createElement(i, we({
    ref: u,
    className: ae(`${h}${o ? ` ${o}` : ""}`),
    "data-swiper-slide-index": c
  }, p), e.createElement(fe.Provider, {
    value: g
  }, d ? e.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": "number" == typeof d ? d : void 0
  }, v()) : v()));
});
Ae.displayName = "SwiperSlide";
o("/**\n * Swiper 8.4.7\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * https://swiperjs.com\n *\n * Copyright 2014-2023 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: January 30, 2023\n */\n\n@font-face{font-family:swiper-icons;src:url('data:application/font-woff;charset=utf-8;base64, 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');font-weight:400;font-style:normal}:root{--swiper-theme-color:#007aff}.swiper{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;box-sizing:content-box}.swiper-android .swiper-slide,.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-pointer-events{touch-action:pan-y}.swiper-pointer-events.swiper-vertical{touch-action:pan-x}.swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform}.swiper-slide-invisible-blank{visibility:hidden}.swiper-autoheight,.swiper-autoheight .swiper-slide{height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden .swiper-slide{transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-3d,.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d .swiper-slide,.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top,.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-3d .swiper-slide-shadow{background:rgba(0,0,0,.15)}.swiper-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.swiper-horizontal.swiper-css-mode>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-vertical.swiper-css-mode>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-centered>.swiper-wrapper::before{content:'';flex-shrink:0;order:9999}.swiper-centered.swiper-horizontal>.swiper-wrapper>.swiper-slide:first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-horizontal>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-centered.swiper-vertical>.swiper-wrapper>.swiper-slide:first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-vertical>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-centered>.swiper-wrapper>.swiper-slide{scroll-snap-align:center center;scroll-snap-stop:always}");
export { v as $, ve as S, Ae as a, ee as b, p as g };